import React from 'react';
import * as uiLibraryReact from '@tolk-ai/ui-library-react';
import { PageLayoutContent, PageLayoutContentTitle, PageLayoutContentDescribe, Button, Accordion, DragAndDrop, ButtonGroup, ButtonGroupButton, DragAndDropListItem, Label, FieldSetInput, FieldSetInputSelect, Option, FieldSet, ErrorMessage, InternalLink, Icon, PageLayoutTitle, Input, PageLayout, Toast, PageLayoutLoading, PageLayoutError, Select, List, ListItemWithEmptyBullet, ListItemWithIcon, Upload } from '@tolk-ai/ui-library-react';
import * as genericUtils from '@tolk-ai/generic-utils';
import * as smartSkills from '@tolk-ai/content-management-smart-skills';
import classNames from 'classnames';

const FormContext = /*#__PURE__*/React.createContext({
  // eslint-disable-next-line @typescript-eslint/no-empty-function
  setState: () => {},
  state: {
    formFields: {
      answers: {
        answersAccordions: [],
        scenarioConditionTargetOptions: []
      },
      questions: {
        apisList: [],
        fields: []
      },
      questionsAndAnswers: [],
      setup: {
        title: '',
        titleInputName: 'setupTitle'
      }
    },
    formState: {
      isLoading: false
    },
    title: '',
    type: 'form'
  }
});

const onDeleteChoicesButtonButtonClick = (choicesButtonFields, state, setState, accordionIdentifier) => event => {
  const updatedAnswersAccordion = state.formFields.answers.answersAccordions.map(answer => {
    if (answer.accordionIdentifier !== accordionIdentifier) {
      return answer;
    }

    return Object.assign(Object.assign({}, answer), {
      actions: answer.actions.map(action => {
        if (action.type === 'buttons') {
          return Object.assign(Object.assign({}, action), {
            choicesButtonsFields: Object.assign(Object.assign({}, action.choicesButtonsFields), {
              choicesButtons: choicesButtonFields.choicesButtons.filter(choiceButton => choiceButton.elementId !== event.currentTarget.name)
            })
          });
        }

        return action;
      })
    });
  });
  setState(Object.assign(Object.assign({}, state), {
    formFields: Object.assign(Object.assign({}, state.formFields), {
      answers: Object.assign(Object.assign({}, state.formFields.answers), {
        answersAccordions: updatedAnswersAccordion
      })
    })
  }));
};

const onChoicesButtonSelectsChange = (state, setState, accordionIdentifier) => choiceButtonSelectName => value => {
  const updatedAnswersAccordion = state.formFields.answers.answersAccordions.map(answer => {
    if (answer.accordionIdentifier !== accordionIdentifier) {
      return answer;
    }

    return Object.assign(Object.assign({}, answer), {
      actions: answer.actions.map(action => {
        if (action.type === 'buttons') {
          return Object.assign(Object.assign({}, action), {
            choicesButtonsFields: Object.assign(Object.assign({}, action.choicesButtonsFields), {
              choicesButtons: action.choicesButtonsFields.choicesButtons.map(choicesButton => {
                if (choicesButton.typeSelectName === choiceButtonSelectName) {
                  return Object.assign(Object.assign({}, choicesButton), {
                    type: value
                  });
                }

                if (choicesButton.questionIdSelectName === choiceButtonSelectName) {
                  return Object.assign(Object.assign({}, choicesButton), {
                    questionId: value
                  });
                }

                return choicesButton;
              })
            })
          });
        }

        return action;
      })
    });
  });
  setState(Object.assign(Object.assign({}, state), {
    formFields: Object.assign(Object.assign({}, state.formFields), {
      answers: Object.assign(Object.assign({}, state.formFields.answers), {
        answersAccordions: updatedAnswersAccordion
      })
    })
  }));
};

const onChoicesButtonInputsChange$1 = (state, setState, accordionIdentifier) => event => {
  const updatedAnswersAccordion = state.formFields.answers.answersAccordions.map(answer => {
    if (answer.accordionIdentifier !== accordionIdentifier) {
      return answer;
    }

    return Object.assign(Object.assign({}, answer), {
      actions: answer.actions.map(action => {
        if (action.type === 'buttons') {
          return Object.assign(Object.assign({}, action), {
            choicesButtonsFields: Object.assign(Object.assign({}, action.choicesButtonsFields), {
              choicesButtons: action.choicesButtonsFields.choicesButtons.map(choicesButton => {
                if (choicesButton.titleInputName === event.target.name) {
                  return Object.assign(Object.assign({}, choicesButton), {
                    title: event.target.value
                  });
                }

                if ((choicesButton.type === 'link' || choicesButton.type === 'urlNewTab') && choicesButton.urlInputName === event.target.name) {
                  return Object.assign(Object.assign({}, choicesButton), {
                    url: event.target.value
                  });
                }

                return choicesButton;
              })
            })
          });
        }

        return action;
      })
    });
  });
  setState(Object.assign(Object.assign({}, state), {
    formFields: Object.assign(Object.assign({}, state.formFields), {
      answers: Object.assign(Object.assign({}, state.formFields.answers), {
        answersAccordions: updatedAnswersAccordion
      })
    })
  }));
};

const defaultPictureProperties = {
  elementId: '',
  inputName: '',
  name: '',
  type: 'picture',
  url: ''
};
const defaultGoToSkillProperties = {
  elementId: '',
  nameSelectName: '',
  type: 'goToSkill'
};
const defaultApiProperties$1 = {
  customerApiId: '',
  elementId: '',
  inputValues: [],
  nameSelectName: '',
  outputs: [],
  type: 'api'
};
const defaultChoiceButton$1 = {
  elementId: '',
  questionIdSelectName: '',
  title: '',
  titleInputName: '',
  type: 'link',
  typeSelectName: '',
  url: '',
  urlInputName: ''
};
const defaultButtonsProperties = {
  choicesButtonsFields: {
    choicesButtons: []
  },
  elementId: '',
  title: '',
  titleInputName: '',
  type: 'buttons'
};
const defaultTextProperties = {
  elementId: '',
  title: '',
  titleInputName: '',
  type: 'text'
};
const answersScenarioAccordion = {
  accordionIdentifier: '',
  actions: [],
  isOpen: true,
  name: '',
  scenarioConditionsField: {
    scenarioConditions: []
  },
  type: 'scenario'
};

const onPictureAddButtonClick = (state, setState) => event => {
  const newPicture = Object.assign(Object.assign({}, defaultPictureProperties), {
    elementId: genericUtils.generateRandomTagId(),
    inputName: `#typePicture#${genericUtils.generateRandomTagId()}`
  });
  const updatedAnswersAccordion = state.formFields.answers.answersAccordions.map(answer => {
    if (answer.accordionIdentifier === event.currentTarget.name) {
      return Object.assign(Object.assign({}, answer), {
        actions: [...answer.actions, newPicture]
      });
    }

    return answer;
  });
  setState(Object.assign(Object.assign({}, state), {
    formFields: Object.assign(Object.assign({}, state.formFields), {
      answers: Object.assign(Object.assign({}, state.formFields.answers), {
        answersAccordions: updatedAnswersAccordion
      })
    })
  }));
};

const onGoToSkillAddButtonClick = (state, setState) => event => {
  const newGoToSkillType = Object.assign(Object.assign({}, defaultGoToSkillProperties), {
    elementId: genericUtils.generateRandomTagId(),
    nameSelectName: `#typeGotoSkillAnswers#${genericUtils.generateRandomTagId()}`
  });
  const updatedAnswersAccordion = state.formFields.answers.answersAccordions.map(answer => {
    if (answer.accordionIdentifier === event.currentTarget.name) {
      return Object.assign(Object.assign({}, answer), {
        actions: [...answer.actions, newGoToSkillType]
      });
    }

    return answer;
  });
  setState(Object.assign(Object.assign({}, state), {
    formFields: Object.assign(Object.assign({}, state.formFields), {
      answers: Object.assign(Object.assign({}, state.formFields.answers), {
        answersAccordions: updatedAnswersAccordion
      })
    })
  }));
};

const onAddApiButtonClick = (state, setState) => event => {
  const newTypeApi = Object.assign(Object.assign({}, defaultApiProperties$1), {
    elementId: genericUtils.generateRandomTagId(),
    nameSelectName: `#typeApiAnswers#${genericUtils.generateRandomTagId()}`
  });
  const updatedAnswersAccordion = state.formFields.answers.answersAccordions.map(answer => {
    if (answer.accordionIdentifier === event.currentTarget.name) {
      return Object.assign(Object.assign({}, answer), {
        actions: [...answer.actions, newTypeApi]
      });
    }

    return answer;
  });
  setState(Object.assign(Object.assign({}, state), {
    formFields: Object.assign(Object.assign({}, state.formFields), {
      answers: Object.assign(Object.assign({}, state.formFields.answers), {
        answersAccordions: updatedAnswersAccordion
      })
    })
  }));
};

const onDeleteTypeButtonClick = (state, setState, accordionIdentifier) => event => {
  const updatedAnswersAccordion = state.formFields.answers.answersAccordions.map(answer => {
    if (answer.accordionIdentifier !== accordionIdentifier) {
      return answer;
    }

    return Object.assign(Object.assign({}, answer), {
      actions: answer.actions.filter(action => {
        if (action.type === 'picture') {
          return action.elementId !== event.currentTarget.name;
        }

        if (action.type === 'goToSkill') {
          return action.elementId !== event.currentTarget.name;
        }

        if (action.type === 'text') {
          return action.elementId !== event.currentTarget.name;
        }

        if (action.type === 'buttons') {
          return action.elementId !== event.currentTarget.name;
        }

        return action.elementId !== event.currentTarget.name;
      })
    });
  });
  setState(Object.assign(Object.assign({}, state), {
    formFields: Object.assign(Object.assign({}, state.formFields), {
      answers: Object.assign(Object.assign({}, state.formFields.answers), {
        answersAccordions: updatedAnswersAccordion
      })
    })
  }));
};

const onAddButtonsClick = (state, setState) => event => {
  const randomTagId = genericUtils.generateRandomTagId();
  const subRandomTagId = genericUtils.generateRandomTagId();
  const buttonsToAdd = Object.assign(Object.assign({}, defaultButtonsProperties), {
    choicesButtonsFields: {
      choicesButtons: [Object.assign(Object.assign({}, defaultChoiceButton$1), {
        elementId: subRandomTagId,
        questionIdSelectName: `choicesButtonQuestionId#${subRandomTagId}`,
        titleInputName: `choicesButtonTitle${subRandomTagId}`,
        typeSelectName: `choicesButtonType#${subRandomTagId}`,
        urlInputName: `choicesButtonUrl#${subRandomTagId}`
      })]
    },
    elementId: randomTagId,
    titleInputName: `buttonsTitle#${randomTagId}`
  });
  const updatedAnswersAccordion = state.formFields.answers.answersAccordions.map(answer => {
    if (answer.accordionIdentifier === event.currentTarget.name) {
      return Object.assign(Object.assign({}, answer), {
        actions: [...answer.actions, buttonsToAdd]
      });
    }

    return answer;
  });
  setState(Object.assign(Object.assign({}, state), {
    formFields: Object.assign(Object.assign({}, state.formFields), {
      answers: Object.assign(Object.assign({}, state.formFields.answers), {
        answersAccordions: updatedAnswersAccordion
      })
    })
  }));
};

const onTextAddButtonClick = (state, setState) => event => {
  const textToAdd = Object.assign(Object.assign({}, defaultTextProperties), {
    elementId: genericUtils.generateRandomTagId(),
    titleInputName: `typeTextTitle#${genericUtils.generateRandomTagId()}`
  });
  const updatedAnswersAccordion = state.formFields.answers.answersAccordions.map(answer => {
    if (answer.accordionIdentifier === event.currentTarget.name) {
      return Object.assign(Object.assign({}, answer), {
        actions: [...answer.actions, textToAdd]
      });
    }

    return answer;
  });
  setState(Object.assign(Object.assign({}, state), {
    formFields: Object.assign(Object.assign({}, state.formFields), {
      answers: Object.assign(Object.assign({}, state.formFields.answers), {
        answersAccordions: updatedAnswersAccordion
      })
    })
  }));
};

const onAddScenarioClick = (state, setState) => () => {
  const randomTagId = genericUtils.generateRandomTagId();
  const currentScenarios = state.formFields.answers.answersAccordions.filter(answerAccordion => {
    return answerAccordion.type === 'scenario';
  });
  const scenarioToAdd = Object.assign(Object.assign({}, answersScenarioAccordion), {
    accordionIdentifier: `scenarioAccordion#${randomTagId}`,
    name: `Scenario#${currentScenarios.length + genericUtils.NUMBER.INCREMENTATION_ONE}`,
    scenarioConditionsField: {
      scenarioConditions: [{
        elementId: randomTagId,
        matchInputName: `scenarioConditionMatch#${randomTagId}`,
        matchOptions: [],
        operator: 'equal',
        operatorSelectName: `scenarioConditionOperator#${randomTagId}`,
        statement: 'if',
        targetSelectName: `scenarioConditionTarget#${randomTagId}`
      }]
    }
  });
  setState(Object.assign(Object.assign({}, state), {
    formFields: Object.assign(Object.assign({}, state.formFields), {
      answers: Object.assign(Object.assign({}, state.formFields.answers), {
        answersAccordions: [...state.formFields.answers.answersAccordions, scenarioToAdd]
      })
    })
  }));
};

const onDeleteAccordionButtonClick = (state, setState) => event => {
  const filteredAnswersAccordions = state.formFields.answers.answersAccordions.filter(accordion => accordion.accordionIdentifier !== event.currentTarget.name);
  setState(Object.assign(Object.assign({}, state), {
    formFields: Object.assign(Object.assign({}, state.formFields), {
      answers: Object.assign(Object.assign({}, state.formFields.answers), {
        answersAccordions: filteredAnswersAccordions
      })
    })
  }));
};

const convertToConditionsTargetOptions = questionsFields => {
  return questionsFields.reduce((accumulator, current) => {
    if (current.type === 'free-input' && current.assignment !== '') {
      return [...accumulator, {
        displayedValue: current.assignment,
        elementId: current.elementId,
        type: 'free-input',
        value: `free-input|${current.assignment}`
      }];
    }

    if (current.type === 'api') {
      if (genericUtils.isEmpty(current.outputs)) {
        return [...accumulator];
      }

      const availableOutput = current.outputs.map(output => {
        return {
          displayedValue: output.name,
          elementId: current.elementId,
          type: 'customer-api',
          value: `${current.customerApiId}|customer-api|${output.name}`
        };
      });
      return [...accumulator, ...availableOutput];
    }

    if (current.type === 'choices') {
      return [...accumulator, {
        displayedValue: current.assignment,
        elementId: current.elementId,
        type: 'choices',
        value: `choices|${current.assignment}`
      }];
    }

    return [...accumulator];
  }, []);
};

const updateAccordionWhenQuestionIsDeleted = (deletedButtonName, state) => {
  const deletedQuestion = state.formFields.questions.fields.find(question => {
    return question.type === 'free-input' && question.elementId === deletedButtonName || question.type === 'choices' && question.elementId === deletedButtonName || question.type === 'api' && question.elementId === deletedButtonName;
  });

  if (typeof deletedQuestion === 'undefined') {
    return state.formFields.answers.answersAccordions;
  }

  return state.formFields.answers.answersAccordions.map(accordion => {
    if (typeof accordion.scenarioConditionsField === 'undefined') {
      return accordion;
    }

    return Object.assign(Object.assign({}, accordion), {
      scenarioConditionsField: Object.assign(Object.assign({}, accordion.scenarioConditionsField), {
        scenarioConditions: accordion.scenarioConditionsField.scenarioConditions.map(scenarioCondition => {
          if (deletedQuestion.type === 'choices') {
            if (deletedQuestion.assignment === (typeof scenarioCondition.target !== 'undefined' && scenarioCondition.target.replace(/^(?:[\0-\t\x0B\f\x0E-\u2027\u202A-\uD7FF\uE000-\uFFFF]|[\uD800-\uDBFF][\uDC00-\uDFFF]|[\uD800-\uDBFF](?![\uDC00-\uDFFF])|(?:[^\uD800-\uDBFF]|^)[\uDC00-\uDFFF])*\|customer\x2Dapi\||free\x2Dinput\||choices\|/, ''))) {
              return Object.assign(Object.assign({}, scenarioCondition), {
                match: undefined,
                target: undefined
              });
            }

            return scenarioCondition;
          }

          if (deletedQuestion.type === 'free-input') {
            if (deletedQuestion.assignment === (typeof scenarioCondition.target !== 'undefined' && scenarioCondition.target.replace(/^(?:[\0-\t\x0B\f\x0E-\u2027\u202A-\uD7FF\uE000-\uFFFF]|[\uD800-\uDBFF][\uDC00-\uDFFF]|[\uD800-\uDBFF](?![\uDC00-\uDFFF])|(?:[^\uD800-\uDBFF]|^)[\uDC00-\uDFFF])*\|customer\x2Dapi\||free\x2Dinput\||choices\|/, ''))) {
              return Object.assign(Object.assign({}, scenarioCondition), {
                target: undefined
              });
            }

            return scenarioCondition;
          }

          if (deletedQuestion.apiId === (typeof scenarioCondition.target !== 'undefined' && scenarioCondition.target.replace(/\|customer\x2Dapi(?:[\0-\t\x0B\f\x0E-\u2027\u202A-\uD7FF\uE000-\uFFFF]|[\uD800-\uDBFF][\uDC00-\uDFFF]|[\uD800-\uDBFF](?![\uDC00-\uDFFF])|(?:[^\uD800-\uDBFF]|^)[\uDC00-\uDFFF])*/, ''))) {
            return Object.assign(Object.assign({}, scenarioCondition), {
              target: undefined
            });
          }

          return scenarioCondition;
        })
      })
    });
  });
};

const updateAccordionsWhenQuestionsChange = (questionType, usedValueInState, updatedSelectValue, state) => {
  const updatedAccordions = state.formFields.answers.answersAccordions.map(accordion => {
    if (typeof accordion.scenarioConditionsField === 'undefined') {
      return accordion;
    }

    const updatedConditionsFieldValue = accordion.scenarioConditionsField.scenarioConditions.map(scenarioConditions => {
      if (typeof usedValueInState !== 'string') {
        const outputsApiIsInUse = usedValueInState.customerApiId === (typeof scenarioConditions.target !== 'undefined' && scenarioConditions.target.replace(/\|customer\x2Dapi(?:[\0-\t\x0B\f\x0E-\u2027\u202A-\uD7FF\uE000-\uFFFF]|[\uD800-\uDBFF][\uDC00-\uDFFF]|[\uD800-\uDBFF](?![\uDC00-\uDFFF])|(?:[^\uD800-\uDBFF]|^)[\uDC00-\uDFFF])*/, ''));

        if (outputsApiIsInUse) {
          return Object.assign(Object.assign({}, scenarioConditions), {
            target: undefined
          });
        }

        return scenarioConditions;
      }

      if (typeof scenarioConditions.target !== 'undefined' && scenarioConditions.target.replace(/^(?:[\0-\t\x0B\f\x0E-\u2027\u202A-\uD7FF\uE000-\uFFFF]|[\uD800-\uDBFF][\uDC00-\uDFFF]|[\uD800-\uDBFF](?![\uDC00-\uDFFF])|(?:[^\uD800-\uDBFF]|^)[\uDC00-\uDFFF])*\|customer\x2Dapi\||free\x2Dinput\||choices\|/, '') !== usedValueInState) {
        return scenarioConditions;
      }

      return Object.assign(Object.assign({}, scenarioConditions), {
        target: genericUtils.isEmpty(updatedSelectValue) || typeof scenarioConditions.target === 'undefined' ? undefined : `${questionType}|${updatedSelectValue}`
      });
    });
    return Object.assign(Object.assign({}, accordion), {
      scenarioConditionsField: Object.assign(Object.assign({}, accordion.scenarioConditionsField), {
        scenarioConditions: updatedConditionsFieldValue
      })
    });
  });
  return updatedAccordions;
};

const onDragStart = (index, draggableItems, setDraggableItems) => () => {
  uiLibraryReact.dragAndDrop.utils.onDragStart(index, draggableItems, setDraggableItems);
};

const onDragOver = (index, draggableItems, setDraggableItems) => () => {
  uiLibraryReact.dragAndDrop.utils.onDragOver(index, draggableItems, setDraggableItems);
};

const onQuestionsTypeDrop = (draggableQuestions, setDraggableQuestions, state, setState) => () => {
  const updatedQuestionsOrder = uiLibraryReact.dragAndDrop.utils.onDrop(Object.assign(Object.assign({}, draggableQuestions), {
    updatedOrder: state.formFields.questions.fields
  }), setDraggableQuestions);
  setState(Object.assign(Object.assign({}, state), {
    formFields: Object.assign(Object.assign({}, state.formFields), {
      questions: Object.assign(Object.assign({}, state.formFields.questions), {
        fields: updatedQuestionsOrder.updatedOrder
      })
    })
  }));
};

const onAnswersTypeDrop = (draggableActions, setDraggableActions, state, setState, answersAccordion) => () => {
  const currentAnswersAccordion = state.formFields.answers.answersAccordions.find(accordion => accordion.accordionIdentifier === answersAccordion.accordionIdentifier);

  if (typeof currentAnswersAccordion === 'undefined') {
    return;
  }

  const updatedActionsOrder = uiLibraryReact.dragAndDrop.utils.onDrop(Object.assign(Object.assign({}, draggableActions), {
    updatedOrder: currentAnswersAccordion.actions
  }), setDraggableActions);
  const updatedAnswersAccordion = state.formFields.answers.answersAccordions.map(answer => {
    if (answer.accordionIdentifier === answersAccordion.accordionIdentifier) {
      return Object.assign(Object.assign({}, answer), {
        actions: updatedActionsOrder.updatedOrder
      });
    }

    return answer;
  });
  setState(Object.assign(Object.assign({}, state), {
    formFields: Object.assign(Object.assign({}, state.formFields), {
      answers: Object.assign(Object.assign({}, state.formFields.answers), {
        answersAccordions: updatedAnswersAccordion
      })
    })
  }));
};

const onChoicesButtonsDrop = (draggableChoices, setDraggableChoices, choicesIdentifier, state, setState) => () => {
  const currentChoices = state.formFields.questions.fields.find(question => {
    return question.type === 'choices' && question.elementId === choicesIdentifier;
  });

  if (typeof currentChoices === 'undefined' || typeof currentChoices !== 'undefined' && currentChoices.type !== 'choices') {
    return;
  }

  const updatedChoicesOrder = uiLibraryReact.dragAndDrop.utils.onDrop(Object.assign(Object.assign({}, draggableChoices), {
    updatedOrder: currentChoices.choicesField.choicesButtons
  }), setDraggableChoices);
  const updatedQuestions = state.formFields.questions.fields.map(question => {
    if (question.type === 'choices' && question.elementId === choicesIdentifier) {
      return Object.assign(Object.assign({}, question), {
        choicesField: Object.assign(Object.assign({}, question.choicesField), {
          choicesButtons: updatedChoicesOrder.updatedOrder
        })
      });
    }

    return question;
  });
  setState(Object.assign(Object.assign({}, state), {
    formFields: Object.assign(Object.assign({}, state.formFields), {
      questions: Object.assign(Object.assign({}, state.formFields.questions), {
        fields: updatedQuestions
      })
    })
  }));
};

const onAnswersChoicesButtonDrop = (draggableChoices, setDraggableChoices, buttonsIdentifier, state, setState, answersAccordionIdentifier) => () => {
  const currentAnswersAccordion = state.formFields.answers.answersAccordions.find(accordion => accordion.accordionIdentifier === answersAccordionIdentifier);

  if (typeof currentAnswersAccordion === 'undefined') {
    return;
  }

  const currentChoices = currentAnswersAccordion.actions.find(action => {
    return action.type === 'buttons' && action.elementId === buttonsIdentifier;
  });

  if (typeof currentChoices === 'undefined' || typeof currentChoices !== 'undefined' && currentChoices.type !== 'buttons') {
    return;
  }

  const updatedChoicesOrder = uiLibraryReact.dragAndDrop.utils.onDrop(Object.assign(Object.assign({}, draggableChoices), {
    updatedOrder: currentChoices.choicesButtonsFields.choicesButtons
  }), setDraggableChoices);
  const updatedAnswersAccordion = state.formFields.answers.answersAccordions.map(answer => {
    if (answer.accordionIdentifier === answersAccordionIdentifier) {
      return Object.assign(Object.assign({}, answer), {
        actions: answer.actions.map(action => {
          if (action.type !== 'buttons') {
            return action;
          }

          return Object.assign(Object.assign({}, action), {
            choicesButtonFields: Object.assign(Object.assign({}, action.choicesButtonsFields), {
              choicesButtons: updatedChoicesOrder.updatedOrder
            })
          });
        })
      });
    }

    return answer;
  });
  setState(Object.assign(Object.assign({}, state), {
    formFields: Object.assign(Object.assign({}, state.formFields), {
      answers: Object.assign(Object.assign({}, state.formFields.answers), {
        answersAccordions: updatedAnswersAccordion
      })
    })
  }));
};

const NUMBER = {
  REQUIRED_LENGTH: 10
};

const convertSmartSkillsDataApiToTypeApiToDisplay = (dataApi, smartSkillsFormDetails) => {
  const correspondingApiDetails = smartSkillsFormDetails.apis.find(smartSkillsFormDetail => {
    return smartSkillsFormDetail.id === dataApi.id;
  });

  if (typeof correspondingApiDetails === 'undefined') {
    return undefined;
  }

  return {
    apiId: correspondingApiDetails.id,
    customerApiId: correspondingApiDetails.id,
    elementId: genericUtils.generateRandomTagId(),
    inputValues: correspondingApiDetails.details.inputs.map(input => {
      return {
        name: input.name
      };
    }),
    nameSelectName: `typeApiQuestions#${genericUtils.generateRandomTagId()}`,
    outputs: correspondingApiDetails.details.outputs.map(output => {
      return {
        name: output.name
      };
    }),
    type: 'api'
  };
};

const convertSmartSkillsQuestionDataChoiceToQuestionTypeChoicesToDisplay = questionDataChoice => {
  const randomKey = `${genericUtils.generateRandomString(NUMBER.REQUIRED_LENGTH)}${genericUtils.generateRandomNumber()}`;
  return {
    assignment: questionDataChoice.assignment,
    assignmentInputName: `choicesAssignment${genericUtils.generateRandomTagId()}`,
    choicesField: {
      choicesButtons: questionDataChoice.buttons.map(button => {
        return {
          assignment: button.assignment,
          assignmentInputName: `choicesButtonAssignment${genericUtils.generateRandomTagId()}`,
          elementId: genericUtils.generateRandomTagId(),
          title: button.title,
          titleInputName: `choicesButtonTitle#${genericUtils.generateRandomTagId()}`
        };
      })
    },
    elementId: `choices#${randomKey}`,
    title: questionDataChoice.title,
    titleInputName: `choicesButtonTitle${genericUtils.generateRandomTagId()}`,
    type: 'choices'
  };
};

const convertSmartSkillQuestionsToQuestionsToDisplay = (smartSkillsQuestions, smartSkillsFormDetails) => {
  const questionsToDisplay = smartSkillsQuestions.map(question => {
    if (question.type === 'customer-api') {
      return convertSmartSkillsDataApiToTypeApiToDisplay(question, smartSkillsFormDetails);
    }

    if (question.type === 'qr') {
      return convertSmartSkillsQuestionDataChoiceToQuestionTypeChoicesToDisplay(question);
    }

    return {
      assignment: question.assignment,
      assignmentInputName: `typeFreeInputAssignment#${genericUtils.generateRandomTagId()}`,
      elementId: genericUtils.generateRandomTagId(),
      title: question.title,
      titleInputName: `typeFreeInputTitle#${genericUtils.generateRandomTagId()}`,
      type: 'free-input'
    };
  }); // eslint-disable-next-line unicorn/no-useless-undefined

  if (questionsToDisplay.includes(undefined)) {
    return undefined;
  }

  const filteredQuestionsToDisplay = questionsToDisplay.filter(question => question !== undefined);
  return filteredQuestionsToDisplay;
};

const convertAnswersDataToAnswerActionsToDisplay = (answersData, smartSkillsFormDetails) => {
  const actions = answersData.map(answerData => {
    const randomTagId = genericUtils.generateRandomTagId();

    if (answerData.type === 'text') {
      const typeText = {
        elementId: randomTagId,
        title: answerData.title,
        titleInputName: `typeTextTitle#${randomTagId}`,
        type: 'text'
      };
      return typeText;
    }

    if (answerData.type === 'button') {
      const subRandomTagId = genericUtils.generateRandomTagId();
      return {
        choicesButtonsFields: {
          choicesButtons: answerData.buttons.map(button => {
            const defaultChoicesButton = {
              elementId: subRandomTagId,
              title: button.title,
              titleInputName: `choicesButtonTitle${subRandomTagId}`
            };

            if (button.type === 'question') {
              return Object.assign(Object.assign({}, defaultChoicesButton), {
                questionId: button.questionId,
                questionIdSelectName: `choicesButtonQuestionId#${subRandomTagId}`,
                type: 'goToQ&A',
                typeSelectName: `choicesButtonType#${subRandomTagId}`
              });
            }

            return Object.assign(Object.assign({}, defaultChoicesButton), {
              type: button.target === 'blank' ? 'urlNewTab' : 'link',
              typeSelectName: `choicesButtonType#${subRandomTagId}`,
              url: button.url,
              urlInputName: `choicesButtonUrl#${subRandomTagId}`
            });
          })
        },
        elementId: `buttons#${randomTagId}`,
        title: answerData.title,
        titleInputName: `buttonsTitle#${randomTagId}`,
        type: 'buttons'
      };
    }

    const typeApi = convertSmartSkillsDataApiToTypeApiToDisplay(answerData, smartSkillsFormDetails);
    return typeApi;
  }); // eslint-disable-next-line unicorn/no-useless-undefined

  if (actions.includes(undefined)) {
    return undefined;
  }

  const filteredActionsToDisplay = actions.filter(action => action !== undefined);
  return filteredActionsToDisplay;
};

const convertScenarioToAnswerConditionsToDisplay = (scenarios, questionsDataChoice) => {
  return scenarios.map((scenario, index) => {
    const randomTagId = genericUtils.generateRandomTagId();
    const condition = {
      elementId: randomTagId,
      match: scenario.content.operator === 'exist' ? undefined : scenario.content.match,
      matchInputName: scenario.content.operator === 'exist' ? undefined : `scenarioConditionMatch#${randomTagId}`,
      matchOptions: [],
      operator: scenario.content.operator,
      operatorSelectName: `operatorSelectLine#${randomTagId}`,
      statement: index === genericUtils.NUMBER.ZERO ? 'if' : 'and',
      target: '',
      targetSelectName: `scenarioConditionTarget#${randomTagId}`
    };

    if (scenario.type === 'button') {
      const subChoices = questionsDataChoice.find(dataChoice => dataChoice.assignment === scenario.content.target);
      return Object.assign(Object.assign({}, condition), {
        matchOptions: typeof subChoices === 'undefined' ? [] : subChoices.buttons.map(button => {
          const subRandomKey = `${genericUtils.generateRandomString(NUMBER.REQUIRED_LENGTH)}${genericUtils.generateRandomNumber()}`;
          return {
            displayedValue: button.assignment,
            identifier: `choiceAssignement#${subRandomKey}`,
            value: button.assignment
          };
        }),
        target: `choices|${scenario.content.target}`
      });
    }

    if (scenario.type === 'customer_api') {
      return Object.assign(Object.assign({}, condition), {
        target: `${scenario.reference}|customer-api|${scenario.content.target}`
      });
    }

    return Object.assign(Object.assign({}, condition), {
      target: `free-input|${scenario.content.target}`
    });
  });
};

const convertSmartSkillAnswersToAnswerToDisplay = (smartSkills, questionsDataChoice) => {
  const answersAccordions = smartSkills.answers.map((smartSkillsAnswer, index) => {
    const randomKey = `${genericUtils.generateRandomString(NUMBER.REQUIRED_LENGTH)}${genericUtils.generateRandomNumber()}`;
    const actions = convertAnswersDataToAnswerActionsToDisplay(smartSkillsAnswer.answers, smartSkills.details);

    if (typeof actions === 'undefined') {
      // eslint-disable-next-line unicorn/no-useless-undefined
      return undefined;
    }

    if (genericUtils.isEmpty(smartSkillsAnswer.scenarios)) {
      return {
        accordionIdentifier: 'elseAccordion',
        actions,
        isOpen: smartSkills.answers.length === genericUtils.ARRAY.ONE_ITEM_LENGTH,
        name: `Else`,
        type: 'default'
      };
    }

    return {
      accordionIdentifier: `scenarioAccordion#${randomKey}`,
      actions,
      isOpen: index === genericUtils.ARRAY.SECOND_INDEX,
      name: `Scenario#${index}`,
      scenarioConditionsField: {
        scenarioConditions: convertScenarioToAnswerConditionsToDisplay(smartSkillsAnswer.scenarios, questionsDataChoice)
      },
      type: 'scenario'
    };
  }); // eslint-disable-next-line unicorn/no-useless-undefined

  if (answersAccordions.includes(undefined)) {
    return undefined;
  }

  const filteredAnswers = answersAccordions.filter(accordion => accordion !== undefined);
  return filteredAnswers;
};

const convertSmartSkillQuestionsToScenarioConditionTargetOptionsInAnswer = (smartSkillsQuestions, smartSkillsFormDetails) => {
  const conditionApiInputOptions = smartSkillsQuestions.reduce((accumulator, current) => {
    const randomKey = `${genericUtils.generateRandomString(NUMBER.REQUIRED_LENGTH)}${genericUtils.generateRandomNumber()}`;

    if (current.type === 'customer-api') {
      const correspondingApiDetails = smartSkillsFormDetails.apis.find(smartSkillsFormDetail => {
        return smartSkillsFormDetail.id === current.id;
      });

      if (typeof correspondingApiDetails === 'undefined') {
        return accumulator;
      }

      const outputsToDisplay = correspondingApiDetails.details.outputs.map(output => {
        const subRandomKey = `${genericUtils.generateRandomString(NUMBER.REQUIRED_LENGTH)}${genericUtils.generateRandomNumber()}`;
        return {
          displayedValue: output.name,
          elementId: `${output.name}#${subRandomKey}`,
          type: 'customer-api',
          value: `${correspondingApiDetails.id}|customer-api|${output.name}`
        };
      });
      return [...accumulator, ...outputsToDisplay];
    }

    const scenarioConditionTargetOptions = {
      displayedValue: current.assignment,
      elementId: `${current.title}#${randomKey}`,
      type: 'free-input',
      value: ``
    };

    if (current.type === 'text') {
      return [...accumulator, Object.assign(Object.assign({}, scenarioConditionTargetOptions), {
        value: `free-input|${current.assignment}`
      })];
    }

    return [...accumulator, Object.assign(Object.assign({}, scenarioConditionTargetOptions), {
      type: 'choices',
      value: `choices|${current.assignment}`
    })];
  }, []);
  return conditionApiInputOptions;
};

const onInitWithExistingSmartSkill = async (botId, smartSkillId, setState, getOneSmartSkillsInfos) => {
  try {
    const result = await getOneSmartSkillsInfos(botId, smartSkillId);

    if (genericUtils.isDomainError(result, smartSkills.appPorts.GetOneSmartSkillInfosErrors)) {
      switch (result) {
        case smartSkills.appPorts.GetOneSmartSkillInfosErrors.inexistingSmartSkill:
        default:
          setState({
            message: 'An error occured, please retry',
            type: 'error'
          });
          return;
      }
    }

    const questionsToDisplay = convertSmartSkillQuestionsToQuestionsToDisplay(result.questions, result.details);

    if (questionsToDisplay === undefined) {
      setState({
        message: 'An error occured, please retry',
        type: 'error'
      });
      return;
    }

    const questionsDataChoice = result.questions.filter(question => question.type === 'qr');
    const answersToDisplay = convertSmartSkillAnswersToAnswerToDisplay(result, questionsDataChoice);

    if (answersToDisplay === undefined) {
      setState({
        message: 'An error occured, please retry',
        type: 'error'
      });
      return;
    }

    const scenarioConditionOptionsInAnswer = convertSmartSkillQuestionsToScenarioConditionTargetOptionsInAnswer(result.questions, result.details);
    setState({
      formFields: {
        answers: Object.assign(Object.assign({}, defaultFormFields.answers), {
          answersAccordions: [...answersToDisplay],
          scenarioConditionTargetOptions: scenarioConditionOptionsInAnswer
        }),
        questions: {
          apisList: convertSmartSkillFormDetailsToApisListToDisplay(result.details),
          fields: questionsToDisplay
        },
        questionsAndAnswers: result.details.questions.map(question => {
          return {
            question: question.text,
            questionId: question.id
          };
        }),
        setup: {
          title: result.name,
          titleInputName: 'setupTitle'
        }
      },
      formState: {
        isLoading: false
      },
      smartSkillId: result.id,
      title: result.name,
      type: 'form'
    });
  } catch (_a) {
    setState({
      message: 'An error occured, please retry',
      type: 'error'
    });
  }
};

const onInitWithInexistingSmartSkill = async (botId, setState, getOneSmartSkillFormDetails) => {
  try {
    const result = await getOneSmartSkillFormDetails(botId);

    if (genericUtils.isDomainError(result, smartSkills.appPorts.GetSmartSkillFormDetailsErrors)) {
      switch (result) {
        case smartSkills.appPorts.GetSmartSkillFormDetailsErrors.inexistingBot:
        default:
          setState({
            message: 'An error occured, please retry',
            type: 'error'
          });
          return;
      }
    }

    setState({
      formFields: Object.assign(Object.assign({}, defaultFormFields), {
        questions: {
          apisList: convertSmartSkillFormDetailsToApisListToDisplay(result),
          fields: []
        },
        questionsAndAnswers: result.questions.map(question => {
          return {
            question: question.text,
            questionId: question.id
          };
        })
      }),
      formState: {
        isLoading: false
      },
      title: 'Create a smart skills',
      type: 'form'
    });
  } catch (_a) {
    setState({
      message: 'An error occured, please retry',
      type: 'error'
    });
  }
};

const defaultFormFields = {
  answers: {
    answersAccordions: [{
      accordionIdentifier: 'AccordionDefault',
      actions: [],
      isOpen: true,
      name: 'Else',
      type: 'default'
    }],
    scenarioConditionTargetOptions: []
  },
  questions: {
    apisList: [],
    fields: []
  },
  questionsAndAnswers: [],
  setup: {
    title: '',
    titleInputName: 'setupTitle'
  }
};

const convertSmartSkillFormDetailsToApisListToDisplay = smartSkillsFormDetails => {
  const apisList = smartSkillsFormDetails.apis.map(api => {
    return {
      inputs: api.details.inputs.map(input => {
        return {
          name: input.name
        };
      }),
      method: api.details.method,
      name: api.name,
      outputs: api.details.outputs.map(output => {
        return {
          name: output.name
        };
      }),
      value: api.id
    };
  });
  return apisList;
};

const init = async (botId, history, setState, getOneSmartSkillsInfos, getOneSmartSkillFormDetails) => {
  setState({
    type: 'loading'
  });

  if (typeof history.location.state === 'undefined') {
    await onInitWithInexistingSmartSkill(botId, setState, getOneSmartSkillFormDetails);
    return;
  }

  const historyLocationState = history.location.state;

  if (typeof historyLocationState.data === 'undefined') {
    setState({
      message: 'An error occured, please retry',
      type: 'error'
    });
    return;
  }

  await onInitWithExistingSmartSkill(botId, historyLocationState.data, setState, getOneSmartSkillsInfos);
};

const onInit = async (botId, history, setState, getOneSmartSkillsInfos, getOneSmartSkillFormDetails) => {
  await init(botId, history, setState, getOneSmartSkillsInfos, getOneSmartSkillFormDetails);
};

const onRetryButtonClick = (botId, history, setState, getOneSmartSkillsInfos, getOneSmartSkillFormDetails) => async () => {
  await init(botId, history, setState, getOneSmartSkillsInfos, getOneSmartSkillFormDetails);
};

const onToastHide = setFeedback => () => {
  setFeedback(null);
};

const defaultSubmittedQuestionsFields = questionFields => {
  return questionFields.map(questionFields => {
    if (questionFields.type === 'api') {
      return Object.assign(Object.assign({}, questionFields), {
        apiNameSelectErrorMessage: undefined
      });
    }

    if (questionFields.type === 'choices') {
      return Object.assign(Object.assign({}, questionFields), {
        choicesField: Object.assign(Object.assign({}, questionFields.choicesField), {
          choicesButtons: questionFields.choicesField.choicesButtons.map(choice => {
            return Object.assign(Object.assign({}, choice), {
              fieldsState: undefined
            });
          }),
          errorMessage: undefined
        }),
        errorMessage: undefined,
        fieldsState: undefined
      });
    }

    return Object.assign(Object.assign({}, questionFields), {
      errorMessage: undefined,
      fieldsState: undefined,
      regexErrorMessage: undefined
    });
  });
};

const defaultSubmittedAnswersAccordions = answersAccordions => {
  return answersAccordions.map(answerAccordion => {
    const defaultSubmittedActions = answerAccordion.actions.map(action => {
      if (action.type === 'goToSkill') {
        return Object.assign(Object.assign({}, action), {
          errorMessage: undefined
        });
      }

      if (action.type === 'text') {
        return Object.assign(Object.assign({}, action), {
          errorMessage: undefined
        });
      }

      if (action.type === 'buttons') {
        const defaultChoicesButton = action.choicesButtonsFields.choicesButtons.map(choicesButton => {
          return Object.assign(Object.assign({}, choicesButton), {
            fieldsState: undefined
          });
        });
        return Object.assign(Object.assign({}, action), {
          choicesButtonFields: Object.assign(Object.assign({}, action.choicesButtonsFields), {
            choicesButtons: defaultChoicesButton,
            errorMessage: undefined
          }),
          errorMessage: undefined
        });
      }

      return Object.assign(Object.assign({}, action), {
        apiNameSelectErrorMessage: undefined
      });
    });

    if (typeof answerAccordion.scenarioConditionsField !== 'undefined') {
      const defaultConditionsLine = answerAccordion.scenarioConditionsField.scenarioConditions.map(conditionLine => {
        return Object.assign(Object.assign({}, conditionLine), {
          scenarioConditionState: undefined
        });
      });
      return Object.assign(Object.assign({}, answerAccordion), {
        actions: defaultSubmittedActions,
        errorMessage: undefined,
        scenarioConditionsField: {
          errorMessage: undefined,
          scenarioConditions: defaultConditionsLine
        }
      });
    }

    return Object.assign(Object.assign({}, answerAccordion), {
      actions: defaultSubmittedActions,
      errorMessage: undefined
    });
  });
};

const checkIfQuestionsTypeContainError = questionFields => {
  const questionsTypeHasError = questionFields.some(questionFields => {
    if (questionFields.type === 'api') {
      return typeof questionFields.apiNameSelectErrorMessage === 'string';
    }

    if (questionFields.type === 'choices') {
      return typeof questionFields.errorMessage === 'string' || typeof questionFields.choicesField.errorMessage === 'string';
    }

    return typeof questionFields.errorMessage === 'string' || typeof questionFields.regexErrorMessage === 'string';
  });
  return questionsTypeHasError;
};

const checkIfActionsContainError = actions => {
  const actionsHasError = actions.some(action => {
    if (action.type === 'goToSkill') {
      return typeof action.errorMessage === 'string';
    }

    if (action.type === 'api') {
      return typeof action.apiNameSelectErrorMessage === 'string';
    }

    if (action.type === 'buttons') {
      return typeof action.errorMessage === 'string' || typeof action.choicesButtonsFields.errorMessage === 'string';
    }

    return typeof action.errorMessage === 'string';
  });
  return actionsHasError;
};

const choicesButtonsWithErrorChecking = choicesButtonFields => {
  const choicesButtonValueWithError = choicesButtonFields.choicesButtons.map(choicesButton => {
    if (choicesButton.type === 'goToQ&A') {
      return Object.assign(Object.assign({}, choicesButton), {
        fieldsState: {
          assignmentHasError: typeof choicesButton.questionId === 'undefined',
          titleHasError: genericUtils.isEmpty(choicesButton.title)
        }
      });
    }

    return Object.assign(Object.assign({}, choicesButton), {
      fieldsState: {
        assignmentHasError: genericUtils.isEmpty(choicesButton.url),
        titleHasError: genericUtils.isEmpty(choicesButton.title)
      }
    });
  });
  const displayFieldSetErrorMessage = choicesButtonValueWithError.some(choiceButtonError => {
    if (typeof choiceButtonError.fieldsState === 'undefined') {
      return false;
    }

    return choiceButtonError.fieldsState.titleHasError === true || choiceButtonError.fieldsState.assignmentHasError === true;
  });
  return {
    choicesButtons: choicesButtonValueWithError,
    errorMessage: displayFieldSetErrorMessage ? 'Buttons fields cannot be empty' : undefined
  };
};

const convertSmartSkillQuestionToQuestionsData = questions => {
  const questionsData = questions.fields.map(question => {
    if (question.type === 'api') {
      return {
        id: question.apiId,
        inputs: question.inputValues.map(input => {
          return {
            name: input.name,
            type: 'custom',
            value: ''
          };
        }),
        type: 'customer-api'
      };
    }

    if (question.type === 'free-input') {
      return {
        assignment: question.assignment,
        title: question.title,
        type: 'text'
      };
    }

    return {
      assignment: question.assignment,
      buttons: question.choicesField.choicesButtons.map(choicesButton => {
        return {
          assignment: choicesButton.assignment,
          title: choicesButton.title
        };
      }),
      title: question.title,
      type: 'qr'
    };
  });
  return questionsData;
};

const convertAnswerAccordionToAnswerData = answerAccordion => {
  const filteredAnswersData = answerAccordion.actions.filter(answerAccordion => answerAccordion.type !== 'picture' && answerAccordion.type !== 'goToSkill');
  const answersData = filteredAnswersData.map(action => {
    if (action.type === 'api') {
      return {
        id: action.apiId,
        type: 'customer-api'
      };
    }

    if (action.type === 'buttons') {
      return {
        buttons: action.choicesButtonsFields.choicesButtons.map(choicesButton => {
          if (choicesButton.type === 'goToQ&A') {
            return {
              questionId: typeof choicesButton.questionId === 'undefined' ? 'INEXISTING QUESTION ID' : choicesButton.questionId,
              title: choicesButton.title,
              type: 'question'
            };
          }

          return {
            target: choicesButton.type === 'link' ? 'self' : 'blank',
            title: choicesButton.title,
            type: 'url',
            url: choicesButton.url
          };
        }),
        title: action.title,
        type: 'button'
      };
    }

    return {
      title: action.title,
      type: 'text'
    };
  });
  return answersData;
};

const convertAnswerAccordionToScenariosContent = scenarioCondition => {
  if (scenarioCondition.operator === 'exist') {
    return {
      operator: 'exist',
      target: typeof scenarioCondition.target === 'undefined' ? '' : scenarioCondition.target.replace(/^(?:[\0-\t\x0B\f\x0E-\u2027\u202A-\uD7FF\uE000-\uFFFF]|[\uD800-\uDBFF][\uDC00-\uDFFF]|[\uD800-\uDBFF](?![\uDC00-\uDFFF])|(?:[^\uD800-\uDBFF]|^)[\uDC00-\uDFFF])*\|customer\x2Dapi\||free\x2Dinput\||choices\|/, '')
    };
  }

  return {
    match: typeof scenarioCondition.match === 'undefined' ? '' : scenarioCondition.match,
    operator: scenarioCondition.operator,
    target: typeof scenarioCondition.target === 'undefined' ? '' : scenarioCondition.target.replace(/^(?:[\0-\t\x0B\f\x0E-\u2027\u202A-\uD7FF\uE000-\uFFFF]|[\uD800-\uDBFF][\uDC00-\uDFFF]|[\uD800-\uDBFF](?![\uDC00-\uDFFF])|(?:[^\uD800-\uDBFF]|^)[\uDC00-\uDFFF])*\|customer\x2Dapi\||free\x2Dinput\||choices\|/, '')
  };
};

const convertAnswerAccordionToScenarios = answerAccordion => {
  if (typeof answerAccordion.scenarioConditionsField === 'undefined') {
    return [];
  }

  const scenario = answerAccordion.scenarioConditionsField.scenarioConditions.map(scenarioCondition => {
    const scenarioContent = convertAnswerAccordionToScenariosContent(scenarioCondition);

    if (typeof scenarioCondition.target !== 'undefined' && scenarioCondition.target.includes('free-input|')) {
      return {
        content: scenarioContent,
        type: 'free_input'
      };
    }

    if (typeof scenarioCondition.target !== 'undefined' && scenarioCondition.target.includes('choices|')) {
      return {
        content: scenarioContent,
        type: 'button'
      };
    }

    return {
      content: scenarioContent,
      reference: typeof scenarioCondition.target !== 'undefined' && scenarioCondition.target.replace(/\|customer\x2Dapi(?:[\0-\t\x0B\f\x0E-\u2027\u202A-\uD7FF\uE000-\uFFFF]|[\uD800-\uDBFF][\uDC00-\uDFFF]|[\uD800-\uDBFF](?![\uDC00-\uDFFF])|(?:[^\uD800-\uDBFF]|^)[\uDC00-\uDFFF])*/, ''),
      type: 'customer_api'
    };
  });
  return scenario;
};

const convertSmartSkillAnswersAccordionsToSmartSkillAnswers = answersAccordions => {
  const smartSkillAnswer = answersAccordions.map(answerAccordion => {
    return {
      answers: convertAnswerAccordionToAnswerData(answerAccordion),
      scenarios: convertAnswerAccordionToScenarios(answerAccordion)
    };
  });
  return smartSkillAnswer;
};

const choicesFieldsWithErrorChecking = choicesFields => {
  const choicesButtonsWithError = choicesFields.choicesButtons.map(button => {
    return Object.assign(Object.assign({}, button), {
      fieldsState: {
        assignmentHasError: genericUtils.isEmpty(button.assignment),
        titleHasError: genericUtils.isEmpty(button.title)
      }
    });
  });
  const displayFieldSetErrorMessage = choicesButtonsWithError.some(buttonError => {
    if (typeof buttonError.fieldsState === 'undefined') {
      return false;
    }

    return buttonError.fieldsState.titleHasError === true || buttonError.fieldsState.assignmentHasError === true;
  });
  return {
    choicesButtons: choicesButtonsWithError,
    errorMessage: displayFieldSetErrorMessage ? 'Choices fields cannot be empty' : undefined
  };
};

const questionsTypesChecking = questionFields => {
  const questionsTypesWithError = questionFields.map(question => {
    if (question.type === 'api') {
      return Object.assign(Object.assign({}, question), {
        apiNameSelectErrorMessage: typeof question.apiId === 'undefined' ? 'You have to select an API' : undefined
      });
    }

    if (question.type === 'choices') {
      return Object.assign(Object.assign({}, question), {
        choicesField: choicesFieldsWithErrorChecking(question.choicesField),
        errorMessage: genericUtils.isEmpty(question.assignment) || genericUtils.isEmpty(question.title) ? 'Choices fields cannot be empty' : undefined,
        fieldsState: Object.assign(Object.assign({}, question.fieldsState), {
          assignmentHasError: genericUtils.isEmpty(question.assignment),
          titleHasError: genericUtils.isEmpty(question.title)
        })
      });
    }

    return Object.assign(Object.assign({}, question), {
      errorMessage: genericUtils.isEmpty(question.assignment) || genericUtils.isEmpty(question.title) ? 'Question fields cannot be empty' : undefined,
      fieldsState: Object.assign(Object.assign({}, question.fieldsState), {
        assignmentHasError: genericUtils.isEmpty(question.assignment),
        titleHasError: genericUtils.isEmpty(question.title)
      }),
      regexErrorMessage: question.validation === 'custom' && question.regex === '' ? 'Custom validation cannot be empty' : undefined
    });
  });
  return questionsTypesWithError;
};

const actionsChecking = actions => {
  const actionsWithErrorChecking = actions.map(action => {
    if (action.type === 'picture') {
      return Object.assign(Object.assign({}, action), {
        errorMessage: genericUtils.isEmpty(action.name) && genericUtils.isEmpty(action.name) ? 'You have to upload a picture' : undefined
      });
    }

    if (action.type === 'goToSkill') {
      return Object.assign(Object.assign({}, action), {
        errorMessage: typeof action.goToSkillId === 'undefined' ? 'You have to select a skill' : undefined
      });
    }

    if (action.type === 'api') {
      return Object.assign(Object.assign({}, action), {
        apiNameSelectErrorMessage: typeof action.apiId === 'undefined' ? 'You have to select an API' : undefined
      });
    }

    if (action.type === 'buttons') {
      return Object.assign(Object.assign({}, action), {
        choicesButtonsFields: choicesButtonsWithErrorChecking(action.choicesButtonsFields),
        errorMessage: genericUtils.isEmpty(action.title) ? 'Buttons fields cannot be empty' : undefined
      });
    }

    return Object.assign(Object.assign({}, action), {
      errorMessage: genericUtils.isEmpty(action.title) ? 'Answer text cannot be empty' : undefined
    });
  });
  return actionsWithErrorChecking;
};

const scenarioConditionsChecking = scenarioConditionsField => {
  if (typeof scenarioConditionsField === 'undefined') {
    return scenarioConditionsField;
  }

  const scenarioConditionsWithError = scenarioConditionsField.scenarioConditions.map(condition => {
    return Object.assign(Object.assign({}, condition), {
      scenarioConditionState: Object.assign(Object.assign({}, condition.scenarioConditionState), {
        matchHasError: condition.operator !== 'exist' && (typeof condition.match === 'undefined' || typeof condition.match !== 'undefined' && genericUtils.isEmpty(condition.match)),
        targetHasError: typeof condition.target === 'undefined'
      })
    });
  });
  const displayFieldSetErrorMessage = scenarioConditionsWithError.some(scenarioConditionValueError => {
    if (typeof scenarioConditionValueError.scenarioConditionState === 'undefined') {
      return false;
    }

    return scenarioConditionValueError.scenarioConditionState.matchHasError === true || scenarioConditionValueError.scenarioConditionState.targetHasError === true;
  });
  return {
    errorMessage: displayFieldSetErrorMessage ? 'Condition fields cannot be empty or not selected' : undefined,
    scenarioConditions: scenarioConditionsWithError
  };
};

const answersAccordionsChecking = accordions => {
  return accordions.map(accordion => {
    return Object.assign(Object.assign({}, accordion), {
      actions: actionsChecking(accordion.actions),
      errorMessage: genericUtils.isEmpty(accordion.actions) ? 'Answer have to contain at least one action' : undefined,
      scenarioConditionsField: scenarioConditionsChecking(accordion.scenarioConditionsField)
    });
  });
};

const checkIfFormContainErrors = fields => {
  if (typeof fields === 'undefined') {
    return false;
  }

  if (typeof fields === 'string') {
    return true;
  }

  return fields.some(field => {
    return typeof field.errorMessage === 'string' || checkIfActionsContainError(field.actions) || typeof field.scenarioConditionsField !== 'undefined' && typeof field.scenarioConditionsField.errorMessage === 'string';
  });
};

const onCreateSmartSkill = async (botId, submittedState, setState, setFeedback, createOneSmartSkill) => {
  try {
    const result = await createOneSmartSkill(botId, {
      answers: convertSmartSkillAnswersAccordionsToSmartSkillAnswers(submittedState.formFields.answers.answersAccordions),
      name: submittedState.formFields.setup.title,
      questions: convertSmartSkillQuestionToQuestionsData(submittedState.formFields.questions)
    });

    if (genericUtils.isDomainError(result, smartSkills.appPorts.CreateOneSmartSkillErrors)) {
      switch (result) {
        case smartSkills.appPorts.CreateOneSmartSkillErrors.inexistingBot:
          setFeedback({
            message: 'An error occured, please retry',
            type: 'danger'
          });
          setState(Object.assign(Object.assign({}, submittedState), {
            formState: {
              isLoading: false
            }
          }));
          break;

        case smartSkills.appPorts.CreateOneSmartSkillErrors.emptyName:
          setFeedback({
            message: 'An error occured with the skill name, please retry',
            type: 'danger'
          });
          setState(Object.assign(Object.assign({}, submittedState), {
            formState: {
              isLoading: false
            }
          }));
          break;

        case smartSkills.appPorts.CreateOneSmartSkillErrors.emptyQuestions:
          setFeedback({
            message: 'An error occured with the question content, please retry',
            type: 'danger'
          });
          setState(Object.assign(Object.assign({}, submittedState), {
            formState: {
              isLoading: false
            }
          }));
          break;

        case smartSkills.appPorts.CreateOneSmartSkillErrors.invalidSmartSkill:
          setFeedback({
            message: 'An error occured on the smart skill validation, please retry',
            type: 'danger'
          });
          setState(Object.assign(Object.assign({}, submittedState), {
            formState: {
              isLoading: false
            }
          }));
          break;

        default:
          setFeedback({
            message: 'An error occured, please retry',
            type: 'danger'
          });
          return;
      }

      return;
    }

    setFeedback({
      message: 'Smart skill was successfully register !',
      type: 'success'
    });
    setState(Object.assign(Object.assign({}, submittedState), {
      formState: {
        isLoading: false
      },
      smartSkillId: result
    }));
  } catch (_a) {
    setState(Object.assign(Object.assign({}, submittedState), {
      formState: {
        isLoading: false
      }
    }));
    setFeedback({
      message: 'An error occured, please retry',
      type: 'danger'
    });
  }
};

const onUpdateSmartSkill = async (botId, smartSkillId, submittedState, setState, setFeedback, updateOneSmartSkill) => {
  try {
    const result = await updateOneSmartSkill(botId, smartSkillId, {
      answers: convertSmartSkillAnswersAccordionsToSmartSkillAnswers(submittedState.formFields.answers.answersAccordions),
      name: submittedState.formFields.setup.title,
      questions: convertSmartSkillQuestionToQuestionsData(submittedState.formFields.questions)
    });

    if (genericUtils.isDomainError(result, smartSkills.appPorts.UpdateOneSmartSkillErrors)) {
      switch (result) {
        case smartSkills.appPorts.UpdateOneSmartSkillErrors.emptyName:
          setFeedback({
            message: 'An error occured with the skill name, please retry',
            type: 'danger'
          });
          setState(Object.assign(Object.assign({}, submittedState), {
            formState: {
              isLoading: false
            }
          }));
          break;

        case smartSkills.appPorts.UpdateOneSmartSkillErrors.emptyQuestions:
          setFeedback({
            message: 'An error occured with the question content, please retry',
            type: 'danger'
          });
          setState(Object.assign(Object.assign({}, submittedState), {
            formState: {
              isLoading: false
            }
          }));
          break;

        case smartSkills.appPorts.UpdateOneSmartSkillErrors.inexistingSmartSkill:
          setFeedback({
            message: 'An error occured, please retry',
            type: 'danger'
          });
          setState(Object.assign(Object.assign({}, submittedState), {
            formState: {
              isLoading: false
            }
          }));
          break;

        case smartSkills.appPorts.UpdateOneSmartSkillErrors.invalidSmartSkill:
          setFeedback({
            message: 'An error occured on the smart skill validation, please retry',
            type: 'danger'
          });
          setState(Object.assign(Object.assign({}, submittedState), {
            formState: {
              isLoading: false
            }
          }));
          break;

        default:
          setFeedback({
            message: 'An error occured, please retry',
            type: 'danger'
          });
          return;
      }

      return;
    }

    setFeedback({
      message: 'Smart skill was successfully updated !',
      type: 'success'
    });
    setState(Object.assign(Object.assign({}, submittedState), {
      formState: {
        isLoading: false
      },
      title: submittedState.formFields.setup.title
    }));
  } catch (_a) {
    setState(Object.assign(Object.assign({}, submittedState), {
      formState: {
        isLoading: false
      }
    }));
    setFeedback({
      message: 'An error occured, please retry',
      type: 'danger'
    });
  }
};

const onSubmit = (botId, state, setState, setFeedback, createOneSmartSkill, updateOneSmartSkill) => async event => {
  event.preventDefault();
  const submitFormField = {
    answers: Object.assign(Object.assign({}, state.formFields.answers), {
      answersAccordions: defaultSubmittedAnswersAccordions(state.formFields.answers.answersAccordions)
    }),
    questions: Object.assign(Object.assign({}, state.formFields.questions), {
      fields: defaultSubmittedQuestionsFields(state.formFields.questions.fields)
    }),
    questionsAndAnswers: [...state.formFields.questionsAndAnswers],
    setup: Object.assign(Object.assign({}, state.formFields.setup), {
      errorMessage: undefined,
      title: state.formFields.setup.title
    })
  };
  const submittedState = {
    formFields: submitFormField,
    formState: {
      isLoading: true
    },
    smartSkillId: state.smartSkillId,
    title: state.formFields.setup.title,
    type: 'form'
  };
  setState(submittedState);
  const smartSkillNameErrorMessage = genericUtils.isEmpty(submitFormField.setup.title) ? 'Smart skill name cannot be empty' : undefined;
  const questionsFieldsErrorMessage = genericUtils.isEmpty(submitFormField.questions.fields) ? 'Question have to contain at least one element' : undefined;
  const answersAccordionsWithErrorChecking = answersAccordionsChecking(submitFormField.answers.answersAccordions);
  const questionsTypesWithErrorChecking = questionsTypesChecking(submitFormField.questions.fields);

  if (checkIfFormContainErrors(smartSkillNameErrorMessage) || checkIfFormContainErrors(questionsFieldsErrorMessage) || checkIfFormContainErrors(answersAccordionsWithErrorChecking) || checkIfQuestionsTypeContainError(questionsTypesWithErrorChecking)) {
    setFeedback({
      message: 'Some fields seem incorrect, please check and retry',
      type: 'danger'
    });
    setState(Object.assign(Object.assign({}, submittedState), {
      formFields: Object.assign(Object.assign({}, submitFormField), {
        answers: Object.assign(Object.assign({}, submitFormField.answers), {
          answersAccordions: answersAccordionsWithErrorChecking
        }),
        questions: Object.assign(Object.assign({}, submitFormField.questions), {
          errorMessage: questionsFieldsErrorMessage,
          fields: questionsTypesWithErrorChecking
        }),
        setup: Object.assign(Object.assign({}, submitFormField.setup), {
          errorMessage: smartSkillNameErrorMessage
        })
      }),
      formState: Object.assign(Object.assign({}, submittedState.formState), {
        isLoading: false
      })
    }));
    return;
  }

  if (typeof submittedState.smartSkillId === 'undefined') {
    await onCreateSmartSkill(botId, submittedState, setState, setFeedback, createOneSmartSkill);
    return;
  }

  await onUpdateSmartSkill(botId, submittedState.smartSkillId, submittedState, setState, setFeedback, updateOneSmartSkill);
};

const ifAccordionUseChoicesAssignementInConditions = (currentChoices, accordion) => {
  if (typeof accordion.scenarioConditionsField === 'undefined') {
    return false;
  }

  const isInUse = accordion.scenarioConditionsField.scenarioConditions.some(scenarioCondition => {
    if (typeof scenarioCondition.target === 'undefined') {
      return false;
    }

    return scenarioCondition.target.replace(/^(?:[\0-\t\x0B\f\x0E-\u2027\u202A-\uD7FF\uE000-\uFFFF]|[\uD800-\uDBFF][\uDC00-\uDFFF]|[\uD800-\uDBFF](?![\uDC00-\uDFFF])|(?:[^\uD800-\uDBFF]|^)[\uDC00-\uDFFF])*\|customer\x2Dapi\||free\x2Dinput\||choices\|/, '') === currentChoices.assignment;
  });
  return isInUse;
};

const convertChoicesButtonsToScenarioConditionMatchOptions = choicesButtons => {
  console.log('update choices button in match');
  const updatedMatchOptions = choicesButtons.reduce((accumulator, current) => {
    if (genericUtils.isEmpty(current.assignment)) {
      return accumulator;
    }

    return [...accumulator, {
      displayedValue: current.assignment,
      identifier: `choiceAssignement#${genericUtils.generateRandomTagId()}`,
      value: current.assignment
    }];
  }, []);
  console.log('🚀 ~ file: index.tsx:62 ~ updatedMatchOptions', updatedMatchOptions);
  return updatedMatchOptions;
};

const onChoicesButtonInputsChange = (choicesIdentifier, state, setState) => event => {
  const updatedQuestions = state.formFields.questions.fields.map(question => {
    if (question.type === 'choices' && question.elementId === choicesIdentifier) {
      return Object.assign(Object.assign({}, question), {
        choicesField: Object.assign(Object.assign({}, question.choicesField), {
          choicesButtons: question.choicesField.choicesButtons.map(choicesButton => {
            if (choicesButton.titleInputName === event.target.name) {
              return Object.assign(Object.assign({}, choicesButton), {
                title: event.target.value
              });
            }

            if (choicesButton.assignmentInputName === event.target.name) {
              return Object.assign(Object.assign({}, choicesButton), {
                assignment: event.target.value
              });
            }

            return choicesButton;
          })
        })
      });
    }

    return question;
  });
  const updatedCurrentChoices = updatedQuestions.find(question => question.type === 'choices' && question.elementId === choicesIdentifier);
  const currentChoices = state.formFields.questions.fields.find(question => question.type === 'choices' && question.elementId === choicesIdentifier);
  const updatedModifiedChoice = updatedCurrentChoices.choicesField.choicesButtons.find(choicesButton => choicesButton.assignmentInputName === event.target.name);
  const modifiedChoice = currentChoices.choicesField.choicesButtons.find(choicesButton => choicesButton.assignmentInputName === event.target.name);
  const updatedAccordions = state.formFields.answers.answersAccordions.map(accordion => {
    if (typeof accordion.scenarioConditionsField === 'undefined') {
      return accordion;
    }

    if (ifAccordionUseChoicesAssignementInConditions(currentChoices, accordion) === false) {
      return accordion;
    }

    if (typeof updatedModifiedChoice === 'undefined' || typeof modifiedChoice === 'undefined') {
      return accordion;
    }

    const updatedAssignment = genericUtils.isEmpty(updatedModifiedChoice.assignment) ? undefined : updatedModifiedChoice.assignment;
    return Object.assign(Object.assign({}, accordion), {
      scenarioConditionsField: Object.assign(Object.assign({}, accordion.scenarioConditionsField), {
        scenarioConditions: accordion.scenarioConditionsField.scenarioConditions.map(scenarioCondition => {
          return Object.assign(Object.assign({}, scenarioCondition), {
            match: modifiedChoice.assignment === scenarioCondition.match ? updatedAssignment : scenarioCondition.match,
            matchOptions: convertChoicesButtonsToScenarioConditionMatchOptions(updatedCurrentChoices.choicesField.choicesButtons)
          });
        })
      })
    });
  });
  setState(Object.assign(Object.assign({}, state), {
    formFields: Object.assign(Object.assign({}, state.formFields), {
      answers: Object.assign(Object.assign({}, state.formFields.answers), {
        answersAccordions: updatedAccordions
      }),
      questions: Object.assign(Object.assign({}, state.formFields.questions), {
        fields: updatedQuestions
      })
    })
  }));
};

const onDeleteButtonClick$1 = (choicesField, choicesIdentifier, state, setState) => event => {
  const filteredChoicesButtonsFields = choicesField.choicesButtons.filter(choicesButton => choicesButton.elementId !== event.currentTarget.name);
  const updatedQuestions = state.formFields.questions.fields.map(question => {
    if (question.type === 'choices' && question.elementId === choicesIdentifier) {
      return Object.assign(Object.assign({}, question), {
        choicesField: Object.assign(Object.assign({}, question.choicesField), {
          choicesButtons: filteredChoicesButtonsFields
        })
      });
    }

    return question;
  });
  const currentChoices = state.formFields.questions.fields.find(question => question.type === 'choices' && question.elementId === choicesIdentifier);
  const updatedAccordions = state.formFields.answers.answersAccordions.map(accordion => {
    if (typeof accordion.scenarioConditionsField === 'undefined') {
      return accordion;
    }

    if (ifAccordionUseChoicesAssignementInConditions(currentChoices, accordion) === false) {
      return accordion;
    }

    return Object.assign(Object.assign({}, accordion), {
      scenarioConditionsField: Object.assign(Object.assign({}, accordion.scenarioConditionsField), {
        scenarioConditions: accordion.scenarioConditionsField.scenarioConditions.map(scenarioCondition => {
          return Object.assign(Object.assign({}, scenarioCondition), {
            match: filteredChoicesButtonsFields.some(choicesButton => choicesButton.assignment === scenarioCondition.match) ? scenarioCondition.match : undefined,
            matchOptions: convertChoicesButtonsToScenarioConditionMatchOptions(filteredChoicesButtonsFields)
          });
        })
      })
    });
  });
  setState(Object.assign(Object.assign({}, state), {
    formFields: Object.assign(Object.assign({}, state.formFields), {
      answers: Object.assign(Object.assign({}, state.formFields.answers), {
        answersAccordions: updatedAccordions
      }),
      questions: Object.assign(Object.assign({}, state.formFields.questions), {
        fields: updatedQuestions
      })
    })
  }));
};

const defaultApiProperties = {
  customerApiId: '',
  elementId: '',
  inputValues: [],
  nameSelectName: '',
  outputs: [],
  type: 'api'
};
const defaultFreeInputProperties = {
  assignment: '',
  assignmentInputName: '',
  elementId: '',
  regex: '',
  regexInputName: '',
  title: '',
  titleInputName: '',
  type: 'free-input',
  validation: 'none',
  validationSelectName: ''
};
const defaultChoicesProperties = {
  assignment: '',
  assignmentInputName: '',
  choicesField: {
    choicesButtons: []
  },
  elementId: '',
  title: '',
  titleInputName: '',
  type: 'choices'
};

const onFreeInputAddButtonClick = (state, setState) => () => {
  const freeInputToAdd = Object.assign(Object.assign({}, defaultFreeInputProperties), {
    assignmentInputName: `typeFreeInputAssignment#${genericUtils.generateRandomTagId()}`,
    elementId: genericUtils.generateRandomTagId(),
    regexInputName: `typeFreeInputRegex#${genericUtils.generateRandomTagId()}`,
    titleInputName: `typeFreeInputTitle#${genericUtils.generateRandomTagId()}`,
    validationSelectName: `typeFreeInputvalidationSelect#${genericUtils.generateRandomTagId()}`
  });
  setState(Object.assign(Object.assign({}, state), {
    formFields: Object.assign(Object.assign({}, state.formFields), {
      questions: Object.assign(Object.assign({}, state.formFields.questions), {
        fields: [...state.formFields.questions.fields, freeInputToAdd]
      })
    })
  }));
};

const onApiAddButtonClick = (state, setState) => () => {
  const apiToAdd = Object.assign(Object.assign({}, defaultApiProperties), {
    elementId: genericUtils.generateRandomTagId(),
    nameSelectName: `typeApiQuestions#${genericUtils.generateRandomTagId()}`
  });
  setState(Object.assign(Object.assign({}, state), {
    formFields: Object.assign(Object.assign({}, state.formFields), {
      questions: Object.assign(Object.assign({}, state.formFields.questions), {
        fields: [...state.formFields.questions.fields, apiToAdd]
      })
    })
  }));
};

const onChoicesAddButtonClick = (state, setState) => () => {
  const choicesToAdd = Object.assign(Object.assign({}, defaultChoicesProperties), {
    assignmentInputName: `choicesAssignment#${genericUtils.generateRandomTagId()}`,
    choicesField: {
      choicesButtons: [{
        assignment: '',
        assignmentInputName: `choicesButtonAssignment${genericUtils.generateRandomTagId()}`,
        elementId: genericUtils.generateRandomTagId(),
        title: '',
        titleInputName: `choicesButtonTitle#${genericUtils.generateRandomTagId()}`
      }]
    },
    elementId: `choices#${genericUtils.generateRandomTagId()}`,
    titleInputName: `choicesTitle${genericUtils.generateRandomTagId()}`
  });
  setState(Object.assign(Object.assign({}, state), {
    formFields: Object.assign(Object.assign({}, state.formFields), {
      questions: Object.assign(Object.assign({}, state.formFields.questions), {
        fields: [...state.formFields.questions.fields, choicesToAdd]
      })
    })
  }));
};

const onDeleteButtonClick = (state, setState) => event => {
  const filteredQuestionFields = state.formFields.questions.fields.filter(questionField => {
    if (questionField.type === 'free-input') {
      return questionField.elementId !== event.currentTarget.name;
    }

    if (questionField.type === 'choices') {
      return questionField.elementId !== event.currentTarget.name;
    }

    return questionField.elementId !== event.currentTarget.name;
  });
  setState(Object.assign(Object.assign({}, state), {
    formFields: Object.assign(Object.assign({}, state.formFields), {
      answers: Object.assign(Object.assign({}, state.formFields.answers), {
        answersAccordions: updateAccordionWhenQuestionIsDeleted(event.currentTarget.name, state),
        scenarioConditionTargetOptions: convertToConditionsTargetOptions(filteredQuestionFields)
      }),
      questions: Object.assign(Object.assign({}, state.formFields.questions), {
        fields: filteredQuestionFields
      })
    })
  }));
};

const defaultConditionLine = {
  elementId: '',
  matchOptions: [],
  operator: 'equal',
  operatorSelectName: '',
  statement: 'and',
  targetSelectName: ''
};

const onScenarioConditionMatchInputChange = (state, setState, accordionIdentifier) => event => {
  const updatedAnswersAccordion = state.formFields.answers.answersAccordions.map(answer => {
    if (typeof answer.scenarioConditionsField === 'undefined') {
      return answer;
    }

    if (answer.accordionIdentifier === accordionIdentifier) {
      return Object.assign(Object.assign({}, answer), {
        scenarioConditionsField: Object.assign(Object.assign({}, answer.scenarioConditionsField), {
          scenarioConditions: answer.scenarioConditionsField.scenarioConditions.map(scenarioCondition => {
            return scenarioCondition.matchInputName === event.target.name ? Object.assign(Object.assign({}, scenarioCondition), {
              match: event.target.value
            }) : scenarioCondition;
          })
        })
      });
    }

    return answer;
  });
  setState(Object.assign(Object.assign({}, state), {
    formFields: Object.assign(Object.assign({}, state.formFields), {
      answers: Object.assign(Object.assign({}, state.formFields.answers), {
        answersAccordions: updatedAnswersAccordion
      })
    })
  }));
};

const onAddScenarioConditionButtonClick = (state, setState) => event => {
  const randomTagId = genericUtils.generateRandomTagId();
  const conditionToAdd = Object.assign(Object.assign({}, defaultConditionLine), {
    elementId: randomTagId,
    matchInputName: `scenarioConditionMatch#${randomTagId}`,
    operatorSelectName: `scenarioConditionOperator#${randomTagId}`,
    targetSelectName: `scenarioConditionTarget#${randomTagId}`
  });
  const updatedAnswersAccordion = state.formFields.answers.answersAccordions.map(answer => {
    if (typeof answer.scenarioConditionsField === 'undefined') {
      return answer;
    }

    if (answer.accordionIdentifier === event.currentTarget.name) {
      return Object.assign(Object.assign({}, answer), {
        scenarioConditionsField: Object.assign(Object.assign({}, answer.scenarioConditionsField), {
          scenarioConditions: [...answer.scenarioConditionsField.scenarioConditions, conditionToAdd]
        })
      });
    }

    return answer;
  });
  setState(Object.assign(Object.assign({}, state), {
    formFields: Object.assign(Object.assign({}, state.formFields), {
      answers: Object.assign(Object.assign({}, state.formFields.answers), {
        answersAccordions: updatedAnswersAccordion
      })
    })
  }));
};

const onDeleteScenarioConditionButtonClick = (state, setState, accordionIdentifier) => event => {
  const updatedAnswersAccordion = state.formFields.answers.answersAccordions.map(answer => {
    if (typeof answer.scenarioConditionsField === 'undefined') {
      return answer;
    }

    if (answer.accordionIdentifier === accordionIdentifier) {
      return Object.assign(Object.assign({}, answer), {
        scenarioConditionsField: Object.assign(Object.assign({}, answer.scenarioConditionsField), {
          scenarioConditions: answer.scenarioConditionsField.scenarioConditions.filter(scenarioCondition => {
            return scenarioCondition.elementId !== event.currentTarget.name;
          })
        })
      });
    }

    return answer;
  });
  setState(Object.assign(Object.assign({}, state), {
    formFields: Object.assign(Object.assign({}, state.formFields), {
      answers: Object.assign(Object.assign({}, state.formFields.answers), {
        answersAccordions: updatedAnswersAccordion
      })
    })
  }));
};

const updateTargetWithMatchOptions = (selectedValue, scenarioCondition, questions) => {
  if (selectedValue.includes('choices|')) {
    const choiceValue = selectedValue.replace(/^choices\|/, '');
    const questionsTypeChoices = questions.fields.filter(question => question.type === 'choices');
    const selectedChoice = questionsTypeChoices.find(choices => choices.assignment === choiceValue);

    if (typeof selectedChoice === 'undefined') {
      return Object.assign(Object.assign({}, scenarioCondition), {
        match: undefined,
        matchOptions: [],
        target: undefined
      });
    }

    return Object.assign(Object.assign({}, scenarioCondition), {
      match: undefined,
      matchOptions: selectedChoice.choicesField.choicesButtons.reduce((accumulator, current) => {
        const randomTagId = genericUtils.generateRandomTagId();

        if (genericUtils.isEmpty(current.assignment)) {
          return accumulator;
        }

        return [...accumulator, {
          displayedValue: current.assignment,
          identifier: randomTagId,
          value: current.assignment
        }];
      }, []),
      target: selectedValue
    });
  }

  return Object.assign(Object.assign({}, scenarioCondition), {
    match: undefined,
    matchOptions: [],
    target: selectedValue
  });
};

const updateOperator = (selectedValue, condition) => {
  const randomTagId = genericUtils.generateRandomTagId();

  if (selectedValue === 'equal') {
    return Object.assign(Object.assign({}, condition), {
      matchInputName: `scenarioConditionMatch#${randomTagId}`,
      operator: selectedValue
    });
  }

  if (selectedValue !== 'equal' && typeof condition.matchInputName !== 'undefined') {
    return Object.assign(Object.assign({}, condition), {
      matchInputName: undefined,
      operator: selectedValue
    });
  }

  return Object.assign(Object.assign({}, condition), {
    operator: selectedValue
  });
};

const onScenarioConditionSelectsChange = (state, setState, accordionIdentifier) => selectName => value => {
  const updatedAnswersAccordion = state.formFields.answers.answersAccordions.map(answer => {
    if (typeof answer.scenarioConditionsField === 'undefined') {
      return answer;
    }

    if (answer.accordionIdentifier === accordionIdentifier) {
      return Object.assign(Object.assign({}, answer), {
        scenarioConditionsField: Object.assign(Object.assign({}, answer.scenarioConditionsField), {
          scenarioConditions: answer.scenarioConditionsField.scenarioConditions.map(scenarioCondition => {
            if (scenarioCondition.operatorSelectName === selectName) {
              return updateOperator(value, scenarioCondition);
            }

            if (scenarioCondition.targetSelectName === selectName) {
              return updateTargetWithMatchOptions(value, scenarioCondition, state.formFields.questions);
            }

            if (scenarioCondition.matchInputName === selectName) {
              return Object.assign(Object.assign({}, scenarioCondition), {
                match: value
              });
            }

            return scenarioCondition;
          })
        })
      });
    }

    return answer;
  });
  setState(Object.assign(Object.assign({}, state), {
    formFields: Object.assign(Object.assign({}, state.formFields), {
      answers: Object.assign(Object.assign({}, state.formFields.answers), {
        answersAccordions: updatedAnswersAccordion
      })
    })
  }));
};

const onSetupTitleInputChange = (state, setState) => event => {
  setState(Object.assign(Object.assign({}, state), {
    formFields: Object.assign(Object.assign({}, state.formFields), {
      setup: Object.assign(Object.assign({}, state.formFields.setup), {
        title: event.target.value
      })
    })
  }));
};

const onAnswerTypeApiSelectChange = (state, setState) => selectName => value => {
  const updatedAccordions = state.formFields.answers.answersAccordions.map(accordion => {
    const currentTypeApi = accordion.actions.find(action => action.type === 'api' && action.nameSelectName === selectName);

    if (typeof currentTypeApi === 'undefined') {
      return accordion;
    }

    const updatedActions = accordion.actions.map(action => {
      if (action.type !== 'api' || action !== currentTypeApi) {
        return action;
      }

      const selectedApi = state.formFields.questions.apisList.find(api => api.value === value);

      if (typeof selectedApi === 'undefined') {
        return action;
      }

      return Object.assign(Object.assign({}, action), {
        apiId: selectedApi.value,
        inputValues: selectedApi.inputs,
        outputs: selectedApi.outputs,
        type: 'api'
      });
    });
    return Object.assign(Object.assign({}, accordion), {
      actions: updatedActions
    });
  });
  setState(Object.assign(Object.assign({}, state), {
    formFields: Object.assign(Object.assign({}, state.formFields), {
      answers: Object.assign(Object.assign({}, state.formFields.answers), {
        answersAccordions: updatedAccordions
      })
    })
  }));
};

const onQuestionTypeApiSelectChange = (state, setState) => selectName => value => {
  const currentApi = state.formFields.questions.fields.find(question => {
    return question.type === 'api' && question.nameSelectName === selectName;
  });
  const selectedApi = state.formFields.questions.apisList.find(api => api.value === value);

  if (typeof selectedApi === 'undefined' || typeof currentApi === 'undefined' || currentApi.type !== 'api') {
    return;
  }

  const updatedQuestionFields = state.formFields.questions.fields.map(questionField => {
    if (questionField.type === 'api') {
      return questionField.nameSelectName === selectName ? Object.assign(Object.assign({}, questionField), {
        apiId: value,
        customerApiId: value,
        inputValues: selectedApi.inputs,
        outputs: selectedApi.outputs
      }) : questionField;
    }

    return questionField;
  });
  const updatedConditionTargetOptions = convertToConditionsTargetOptions(updatedQuestionFields);
  const updatedAccordions = updateAccordionsWhenQuestionsChange('customer-api', currentApi, '', state);
  setState(Object.assign(Object.assign({}, state), {
    formFields: Object.assign(Object.assign({}, state.formFields), {
      answers: Object.assign(Object.assign({}, state.formFields.answers), {
        answersAccordions: updatedAccordions,
        scenarioConditionTargetOptions: updatedConditionTargetOptions
      }),
      questions: Object.assign(Object.assign({}, state.formFields.questions), {
        fields: updatedQuestionFields
      })
    })
  }));
};

const defaultChoiceButton = {
  elementId: '',
  questionIdSelectName: '',
  title: '',
  titleInputName: '',
  type: 'link',
  typeSelectName: '',
  url: '',
  urlInputName: ''
};

const onTitleButtonsInputChange = (state, setState, accordionIdentifier) => event => {
  const updatedAnswersAccordion = state.formFields.answers.answersAccordions.map(answer => {
    if (answer.accordionIdentifier !== accordionIdentifier) {
      return answer;
    }

    const updatedActions = answer.actions.map(action => {
      if (action.type !== 'buttons') {
        return action;
      }

      return action.titleInputName === event.target.name ? Object.assign(Object.assign({}, action), {
        title: event.target.value
      }) : action;
    });
    return Object.assign(Object.assign({}, answer), {
      actions: updatedActions
    });
  });
  setState(Object.assign(Object.assign({}, state), {
    formFields: Object.assign(Object.assign({}, state.formFields), {
      answers: Object.assign(Object.assign({}, state.formFields.answers), {
        answersAccordions: updatedAnswersAccordion
      })
    })
  }));
};

const onAddChoicesButtonButtonClick = (state, setState, accordionIdentifier) => event => {
  const randomTagId = genericUtils.generateRandomTagId();
  const choiceButtonToAdd = Object.assign(Object.assign({}, defaultChoiceButton), {
    elementId: randomTagId,
    titleInputName: `choicesButtonTitle${randomTagId}`,
    typeSelectName: `choicesButtonType#${randomTagId}`,
    urlInputName: `choicesButtonUrl#${randomTagId}`
  });
  const updatedAnswersAccordion = state.formFields.answers.answersAccordions.map(answer => {
    if (answer.accordionIdentifier !== accordionIdentifier) {
      return answer;
    }

    const updatedActions = answer.actions.map(action => {
      if (action.type === 'buttons' && action.elementId === event.currentTarget.name) {
        return Object.assign(Object.assign({}, action), {
          choicesButtonsFields: Object.assign(Object.assign({}, action.choicesButtonsFields), {
            choicesButtons: [...action.choicesButtonsFields.choicesButtons, choiceButtonToAdd]
          })
        });
      }

      return action;
    });
    return Object.assign(Object.assign({}, answer), {
      actions: updatedActions
    });
  });
  setState(Object.assign(Object.assign({}, state), {
    formFields: Object.assign(Object.assign({}, state.formFields), {
      answers: Object.assign(Object.assign({}, state.formFields.answers), {
        answersAccordions: updatedAnswersAccordion
      })
    })
  }));
};

const defaultChoiceProperties = {
  assignment: '',
  assignmentInputName: '',
  elementId: '',
  title: '',
  titleInputName: ''
};

const onChoicesInputsChange = (state, setState) => event => {
  const currentChoices = state.formFields.questions.fields.find(question => {
    return question.type === 'choices' && (question.titleInputName === event.target.name || question.assignmentInputName === event.target.name);
  });

  if (typeof currentChoices === 'undefined' || currentChoices.type !== 'choices') {
    return;
  }

  const updatedAnswerAccordions = updateAccordionsWhenQuestionsChange(currentChoices.type, currentChoices.assignment, event.target.value, state);
  const updatedQuestionFields = state.formFields.questions.fields.map(questionField => {
    if (questionField.type === 'choices') {
      if (questionField.titleInputName === event.target.name) {
        return Object.assign(Object.assign({}, questionField), {
          title: event.target.value
        });
      }

      if (questionField.assignmentInputName === event.target.name) {
        return Object.assign(Object.assign({}, questionField), {
          assignment: event.target.value
        });
      }
    }

    return questionField;
  });
  const updatedConditionTargetOptions = convertToConditionsTargetOptions(updatedQuestionFields);
  setState(Object.assign(Object.assign({}, state), {
    formFields: Object.assign(Object.assign({}, state.formFields), {
      answers: Object.assign(Object.assign({}, state.formFields.answers), {
        answersAccordions: updatedAnswerAccordions,
        scenarioConditionTargetOptions: updatedConditionTargetOptions
      }),
      questions: Object.assign(Object.assign({}, state.formFields.questions), {
        fields: updatedQuestionFields
      })
    })
  }));
};

const onAddChoicesButtonClick = (state, setState) => event => {
  const choiceToAdd = Object.assign(Object.assign({}, defaultChoiceProperties), {
    assignmentInputName: `choicesButtonAssignment${genericUtils.generateRandomTagId()}`,
    elementId: genericUtils.generateRandomTagId(),
    titleInputName: `choicesButtonTitle#${genericUtils.generateRandomTagId()}`
  });
  const updatedQuestionsField = state.formFields.questions.fields.map(question => {
    if (question.type === 'choices') {
      if (event.currentTarget.name === question.elementId) {
        return Object.assign(Object.assign({}, question), {
          choicesField: Object.assign(Object.assign({}, question.choicesField), {
            choicesButtons: [...question.choicesField.choicesButtons, choiceToAdd]
          })
        });
      }

      return question;
    }

    return question;
  });
  setState(Object.assign(Object.assign({}, state), {
    formFields: Object.assign(Object.assign({}, state.formFields), {
      questions: Object.assign(Object.assign({}, state.formFields.questions), {
        fields: updatedQuestionsField
      })
    })
  }));
};

const onFreeInputInputsChange = (currentElementId, state, setState) => event => {
  const currentFreeInput = state.formFields.questions.fields.find(question => {
    return question.type === 'free-input' && question.elementId === currentElementId;
  });

  if (typeof currentFreeInput === 'undefined' || currentFreeInput.type !== 'free-input') {
    return;
  }

  const updatedAnswerAccordions = updateAccordionsWhenQuestionsChange(currentFreeInput.type, currentFreeInput.assignment, event.target.value, state);
  const updatedQuestionsFields = state.formFields.questions.fields.map(field => {
    if (field.type !== 'free-input') {
      return field;
    }

    if (field.titleInputName === event.target.name) {
      return Object.assign(Object.assign({}, field), {
        title: event.target.value
      });
    }

    if (field.assignmentInputName === event.target.name) {
      return Object.assign(Object.assign({}, field), {
        assignment: event.target.value
      });
    }

    if (field.regexInputName === event.target.name) {
      return Object.assign(Object.assign({}, field), {
        regex: event.target.value
      });
    }

    return field;
  });
  const updatedConditionTargetOptions = convertToConditionsTargetOptions(updatedQuestionsFields);
  setState(Object.assign(Object.assign({}, state), {
    formFields: Object.assign(Object.assign({}, state.formFields), {
      answers: Object.assign(Object.assign({}, state.formFields.answers), {
        answersAccordions: updatedAnswerAccordions,
        scenarioConditionTargetOptions: updatedConditionTargetOptions
      }),
      questions: Object.assign(Object.assign({}, state.formFields.questions), {
        fields: updatedQuestionsFields
      })
    })
  }));
};

const onTypeFreeInputSelectChange = (state, setState) => selectName => value => {
  const currentFreeInput = state.formFields.questions.fields.find(field => {
    return field.type === 'free-input' && field.validationSelectName === selectName;
  });

  if (typeof currentFreeInput === 'undefined') {
    return;
  }

  const updatedQuestionFields = state.formFields.questions.fields.map(questionField => {
    if (questionField.type !== 'free-input' || questionField !== currentFreeInput) {
      return questionField;
    }

    const updatedFreeInput = Object.assign(Object.assign({}, questionField), {
      validation: value
    });
    return updatedFreeInput;
  });
  setState(Object.assign(Object.assign({}, state), {
    formFields: Object.assign(Object.assign({}, state.formFields), {
      questions: Object.assign(Object.assign({}, state.formFields.questions), {
        fields: updatedQuestionFields
      })
    })
  }));
};

const onAnswerTypeGoToSkillSelectChange = (state, setState) => goToSkillSelectName => value => {
  const updatedAccordions = state.formFields.answers.answersAccordions.map(accordion => {
    const currentTypeGoToSkill = accordion.actions.find(action => action.type === 'goToSkill' && action.nameSelectName === goToSkillSelectName);

    if (typeof currentTypeGoToSkill === 'undefined') {
      return accordion;
    }

    const updatedActions = accordion.actions.map(action => {
      if (action.type !== 'goToSkill' || action !== currentTypeGoToSkill) {
        return action;
      }

      return Object.assign(Object.assign({}, action), {
        goToSkillId: value,
        type: 'goToSkill'
      });
    });
    return Object.assign(Object.assign({}, accordion), {
      actions: updatedActions
    });
  });
  setState(Object.assign(Object.assign({}, state), {
    formFields: Object.assign(Object.assign({}, state.formFields), {
      answers: Object.assign(Object.assign({}, state.formFields.answers), {
        answersAccordions: updatedAccordions
      })
    })
  }));
};

const onPictureAnswerChange = (state, setState, accordionIdentifier) => event => {
  const updatedAnswersAccordion = state.formFields.answers.answersAccordions.map(answer => {
    if (answer.accordionIdentifier !== accordionIdentifier) {
      return answer;
    }

    const updatedActions = answer.actions.map(action => {
      if (action.type !== 'picture') {
        return action;
      }

      if (action.inputName !== event.target.name || event.target.files === null) {
        return action;
      }

      const file = event.target.files[genericUtils.ARRAY.FIRST_INDEX];
      const uptadedPicture = Object.assign(Object.assign({}, action), {
        name: file.name,
        url: URL.createObjectURL(file)
      });
      return uptadedPicture;
    });
    return Object.assign(Object.assign({}, answer), {
      actions: updatedActions
    });
  });
  setState(Object.assign(Object.assign({}, state), {
    formFields: Object.assign(Object.assign({}, state.formFields), {
      answers: Object.assign(Object.assign({}, state.formFields.answers), {
        answersAccordions: updatedAnswersAccordion
      })
    })
  }));
};

const onTitleTextInputChange = (state, setState, accordionIdentifier) => event => {
  const updatedAnswersAccordion = state.formFields.answers.answersAccordions.map(answer => {
    if (answer.accordionIdentifier !== accordionIdentifier) {
      return answer;
    }

    const updatedActions = answer.actions.map(action => {
      if (action.type !== 'text') {
        return action;
      }

      return action.titleInputName === event.target.name ? Object.assign(Object.assign({}, action), {
        title: event.target.value
      }) : action;
    });
    return Object.assign(Object.assign({}, answer), {
      actions: updatedActions
    });
  });
  setState(Object.assign(Object.assign({}, state), {
    formFields: Object.assign(Object.assign({}, state.formFields), {
      answers: Object.assign(Object.assign({}, state.formFields.answers), {
        answersAccordions: updatedAnswersAccordion
      })
    })
  }));
};

var styles$h = {"answers-viewer-accordions":"index-module_answers-viewer-accordions__CSc8m","answers-viewer-accordions__add-scenario":"index-module_answers-viewer-accordions__add-scenario__JFItW","answers-viewer-accordions__scenario":"index-module_answers-viewer-accordions__scenario__RcwvE"};

const Answers = ({
  answers
}) => {
  const formContextDatas = React.useContext(FormContext);
  const onAddScenarioClick$1 = onAddScenarioClick(formContextDatas.state, formContextDatas.setState);
  const onTextAddButtonClick$1 = onTextAddButtonClick(formContextDatas.state, formContextDatas.setState);
  const onAddButtonsClick$1 = onAddButtonsClick(formContextDatas.state, formContextDatas.setState);
  const onApiAddButtonClick = onAddApiButtonClick(formContextDatas.state, formContextDatas.setState);
  const onGoToSkillAddButtonClick$1 = onGoToSkillAddButtonClick(formContextDatas.state, formContextDatas.setState);
  const onPictureAddButtonClick$1 = onPictureAddButtonClick(formContextDatas.state, formContextDatas.setState);
  return /*#__PURE__*/React.createElement(PageLayoutContent, null, /*#__PURE__*/React.createElement(PageLayoutContentTitle, null, "Answers"), /*#__PURE__*/React.createElement(PageLayoutContentDescribe, null, "Set your assistant's questions"), /*#__PURE__*/React.createElement("div", {
    className: styles$h['answers-viewer-accordions']
  }, answers.answersAccordions.map(answersAccordion => {
    if (answersAccordion.type === 'scenario') {
      return /*#__PURE__*/React.createElement("div", {
        className: styles$h['answers-viewer-accordions__scenario'],
        key: answersAccordion.accordionIdentifier
      }, /*#__PURE__*/React.createElement(AnswersAccordion, {
        answersAccordion: answersAccordion,
        apisList: formContextDatas.state.formFields.questions.apisList,
        isAccordionOpen: answersAccordion.isOpen,
        onAccordionDeleteButtonClick: onDeleteAccordionButtonClick(formContextDatas.state, formContextDatas.setState),
        onApiAddButtonClick: onApiAddButtonClick,
        onButtonsAddButtonClick: onAddButtonsClick$1,
        onGoToSkillAddButtonClick: onGoToSkillAddButtonClick$1,
        onPictureAddButtonClick: onPictureAddButtonClick$1,
        onTextAddButtonClick: onTextAddButtonClick$1
      }));
    }

    return /*#__PURE__*/React.createElement("div", {
      className: styles$h['answers-viewer-accordions__default-container'],
      key: "default"
    }, /*#__PURE__*/React.createElement("div", {
      className: styles$h['answers-viewer-accordions__add-scenario']
    }, /*#__PURE__*/React.createElement(Button, {
      icon: {
        name: 'PlusIcon',
        position: 'left-icon'
      },
      isOutlined: true,
      onClick: onAddScenarioClick$1,
      type: "button"
    }, "Add scenario")), /*#__PURE__*/React.createElement("div", null, /*#__PURE__*/React.createElement(AnswersAccordion, {
      answersAccordion: answersAccordion,
      apisList: formContextDatas.state.formFields.questions.apisList,
      isAccordionOpen: answersAccordion.isOpen,
      onAccordionDeleteButtonClick: undefined,
      onApiAddButtonClick: onApiAddButtonClick,
      onButtonsAddButtonClick: onAddButtonsClick$1,
      onGoToSkillAddButtonClick: onGoToSkillAddButtonClick$1,
      onPictureAddButtonClick: onPictureAddButtonClick$1,
      onTextAddButtonClick: onTextAddButtonClick$1
    })));
  })));
};

var styles$g = {"answers-viewer-accordion__title":"index-module_answers-viewer-accordion__title__TBDFf","answers-viewer-accordion__element":"index-module_answers-viewer-accordion__element__ZCLyG","answers-viewer-accordion__title--conditions":"index-module_answers-viewer-accordion__title--conditions__EuQrC","answers-viewer-accordion__conditions":"index-module_answers-viewer-accordion__conditions__6cEoD","answers-viewer-accordion__actions":"index-module_answers-viewer-accordion__actions__Cbkv0","answers-viewer-accordion__field-set":"index-module_answers-viewer-accordion__field-set__h7x2r","answers-viewer-accordion__statement":"index-module_answers-viewer-accordion__statement__9isxs","answers-viewer-accordion__select-input-value":"index-module_answers-viewer-accordion__select-input-value__JiHnb","answers-viewer-accordion__select-operator":"index-module_answers-viewer-accordion__select-operator__eB9m-","answers-viewer-accordion__input-conditionnal-value":"index-module_answers-viewer-accordion__input-conditionnal-value__6zujw","answers-viewer-accordion__content-info":"index-module_answers-viewer-accordion__content-info__9F7YR","answers-viewer-accordion__empty-questions":"index-module_answers-viewer-accordion__empty-questions__YrN5G","answers-viewer-accordion__empty-questions-error":"index-module_answers-viewer-accordion__empty-questions-error__5lBCp"};

/* eslint-disable max-lines-per-function */

const AnswersAccordion = ({
  answersAccordion,
  onTextAddButtonClick,
  onAccordionDeleteButtonClick,
  onButtonsAddButtonClick,
  onApiAddButtonClick,
  onGoToSkillAddButtonClick,
  onPictureAddButtonClick,
  apisList,
  isAccordionOpen
}) => {
  return /*#__PURE__*/React.createElement(Accordion, {
    deleteButton: typeof onAccordionDeleteButtonClick === 'undefined' ? undefined : {
      name: answersAccordion.accordionIdentifier,
      onDeleteButtonClick: onAccordionDeleteButtonClick
    },
    isOpen: isAccordionOpen,
    title: answersAccordion.name
  }, /*#__PURE__*/React.createElement(React.Fragment, null, typeof answersAccordion.scenarioConditionsField !== 'undefined' && /*#__PURE__*/React.createElement(Scenario, {
    answersAccordionId: answersAccordion.accordionIdentifier,
    scenarioConditionsField: answersAccordion.scenarioConditionsField
  }), /*#__PURE__*/React.createElement("section", {
    className: styles$g['answers-viewer-accordion__actions']
  }, /*#__PURE__*/React.createElement("h3", {
    className: classNames('label-regular-sm-gray-600', styles$g['answers-viewer-accordion__title'])
  }, "actions"), /*#__PURE__*/React.createElement(DragAndDrop, {
    dragAndDropGroupIdentifier: answersAccordion.accordionIdentifier
  }, /*#__PURE__*/React.createElement(AnswersTypes, {
    answersAccordion: answersAccordion
  })), genericUtils.isEmpty(answersAccordion.actions) && /*#__PURE__*/React.createElement("div", {
    className: styles$g['answers-viewer-accordion__content-info']
  }, /*#__PURE__*/React.createElement("p", {
    className: classNames('text-italic-base-dark', styles$g['answers-viewer-accordion__empty-questions'])
  }, "No answer actions (required)"), typeof answersAccordion.errorMessage === 'string' && /*#__PURE__*/React.createElement("strong", {
    className: classNames('text-regular-sm-danger-500', styles$g['answers-viewer-accordion__empty-questions-error'])
  }, answersAccordion.errorMessage))), /*#__PURE__*/React.createElement("p", {
    className: classNames('text-regular-base-dark', styles$g['answers-viewer-accordion__element'])
  }, "Add element"), /*#__PURE__*/React.createElement(ButtonGroup, null, /*#__PURE__*/React.createElement(ButtonGroupButton, {
    icon: {
      name: 'PencilAltIcon'
    },
    name: answersAccordion.accordionIdentifier,
    onClick: onTextAddButtonClick
  }, "Text"), /*#__PURE__*/React.createElement(ButtonGroupButton, {
    icon: {
      name: 'LinkIcon'
    },
    name: answersAccordion.accordionIdentifier,
    onClick: onButtonsAddButtonClick
  }, "Buttons"), /*#__PURE__*/React.createElement(ButtonGroupButton, {
    icon: {
      name: 'DatabaseIcon'
    },
    isDisabled: genericUtils.isEmpty(apisList),
    name: answersAccordion.accordionIdentifier,
    onClick: onApiAddButtonClick
  }, "API ", /*#__PURE__*/React.createElement("span", {
    className: "sr-only"
  }, "answers")), /*#__PURE__*/React.createElement(ButtonGroupButton, {
    icon: {
      name: 'ShareIcon'
    },
    isDisabled: genericUtils.isEmpty(apisList),
    name: answersAccordion.accordionIdentifier,
    onClick: onGoToSkillAddButtonClick
  }, "Go to skill ", /*#__PURE__*/React.createElement("span", {
    className: "sr-only"
  }, "answers")), /*#__PURE__*/React.createElement(ButtonGroupButton, {
    icon: {
      name: 'PhotographIcon'
    },
    isDisabled: genericUtils.isEmpty(apisList),
    name: answersAccordion.accordionIdentifier,
    onClick: onPictureAddButtonClick
  }, "Picture ", /*#__PURE__*/React.createElement("span", {
    className: "sr-only"
  }, "answers")))));
};

var styles$f = {"choice-button__container":"index-module_choice-button__container__K3ccG","choice-button__inputs":"index-module_choice-button__inputs__Hxld-","choice-button__choice":"index-module_choice-button__choice__dspP3","choice-button__select-button-type":"index-module_choice-button__select-button-type__cmrjC","choice-button__input-for-selected-choice-button-type":"index-module_choice-button__input-for-selected-choice-button-type__wIeeK","choice-button__delete-container--hidden":"index-module_choice-button__delete-container--hidden__QzXJ8"};

/* eslint-disable max-lines-per-function */

const AnswersChoicesButton = ({
  choicesButton,
  onDeleteChoiceButtonButtonClick,
  onChoiceButtonInputsChange,
  onChoiceButtonTypeSelectChange,
  onChoiceButtonQuestionAndAnswerSelectChange,
  onDragOver,
  onDragStart,
  onDrop,
  questionsAndAnswers,
  position
}) => {
  const choiceButtonSelectOptions = [{
    displayedValue: 'Go to Q&A',
    value: 'goToQ&A'
  }, {
    displayedValue: 'URL link',
    value: 'link'
  }, {
    displayedValue: 'URL new tab',
    value: 'urlNewTab'
  }];
  return /*#__PURE__*/React.createElement(DragAndDropListItem, {
    isInline: true,
    key: choicesButton.elementId,
    onDragOver: onDragOver,
    onDragStart: onDragStart,
    onDrop: onDrop
  }, /*#__PURE__*/React.createElement("div", {
    className: styles$f['choice-button__container']
  }, /*#__PURE__*/React.createElement("div", {
    className: styles$f['choice-button__inputs']
  }, /*#__PURE__*/React.createElement("div", {
    className: styles$f['choice-button__choice']
  }, /*#__PURE__*/React.createElement(Label, {
    htmlFor: choicesButton.titleInputName,
    screenReaderOnly: true
  }, "Answers choices button title"), /*#__PURE__*/React.createElement(FieldSetInput, {
    inputIdentifier: choicesButton.titleInputName,
    name: choicesButton.titleInputName,
    onChange: onChoiceButtonInputsChange,
    placeholder: "Choice",
    state: typeof choicesButton.fieldsState !== 'undefined' && choicesButton.fieldsState.titleHasError ? {
      type: 'error'
    } : undefined,
    value: choicesButton.title
  })), /*#__PURE__*/React.createElement("div", {
    className: styles$f['choice-button__select-button-type']
  }, /*#__PURE__*/React.createElement(Label, {
    htmlFor: choicesButton.typeSelectName,
    screenReaderOnly: true
  }, "Answers choices button type"), /*#__PURE__*/React.createElement(FieldSetInputSelect, {
    inputIdentifier: choicesButton.typeSelectName,
    onChange: onChoiceButtonTypeSelectChange(choicesButton.typeSelectName),
    value: choicesButton.type
  }, choiceButtonSelectOptions.map(option => {
    return /*#__PURE__*/React.createElement(Option, {
      isDisabled: option.value === 'goToQ&A' && genericUtils.isEmpty(questionsAndAnswers),
      key: option.value,
      value: option.value
    }, option.displayedValue);
  }))), /*#__PURE__*/React.createElement("div", {
    className: styles$f['choice-button__input-for-selected-choice-button-type']
  }, choicesButton.type === 'goToQ&A' && /*#__PURE__*/React.createElement(React.Fragment, null, /*#__PURE__*/React.createElement(Label, {
    htmlFor: choicesButton.questionIdSelectName,
    screenReaderOnly: true
  }, "Answers choices button select Q&A"), /*#__PURE__*/React.createElement(FieldSetInputSelect, {
    inputIdentifier: choicesButton.questionIdSelectName,
    onChange: onChoiceButtonQuestionAndAnswerSelectChange(choicesButton.questionIdSelectName),
    state: typeof choicesButton.fieldsState !== 'undefined' && choicesButton.fieldsState.assignmentHasError ? {
      type: 'error'
    } : undefined,
    value: choicesButton.questionId
  }, /*#__PURE__*/React.createElement(React.Fragment, null, typeof choicesButton.questionId === 'undefined' && /*#__PURE__*/React.createElement(Option, {
    value: ""
  }, "Choose a Q&A"), questionsAndAnswers.map(questionAndAnswer => {
    return /*#__PURE__*/React.createElement(Option, {
      key: questionAndAnswer.questionId,
      value: questionAndAnswer.questionId
    }, questionAndAnswer.question);
  })))), (choicesButton.type === 'link' || choicesButton.type === 'urlNewTab') && /*#__PURE__*/React.createElement(React.Fragment, null, /*#__PURE__*/React.createElement(Label, {
    htmlFor: choicesButton.urlInputName,
    screenReaderOnly: true
  }, "Answers choices button link"), /*#__PURE__*/React.createElement(FieldSetInput, {
    inputIdentifier: choicesButton.urlInputName,
    name: choicesButton.urlInputName,
    onChange: onChoiceButtonInputsChange,
    placeholder: "https://",
    state: typeof choicesButton.fieldsState !== 'undefined' && choicesButton.fieldsState.assignmentHasError ? {
      type: 'error'
    } : undefined,
    value: choicesButton.url
  })))), /*#__PURE__*/React.createElement("div", {
    className: classNames({
      [styles$f['choice-button__delete-container--hidden']]: position === genericUtils.ARRAY.FIRST_INDEX
    })
  }, /*#__PURE__*/React.createElement(Button, {
    icon: {
      border: 'none',
      name: 'TrashIcon'
    },
    isOutlined: true,
    name: choicesButton.elementId,
    onClick: onDeleteChoiceButtonButtonClick,
    type: "button"
  }))));
};

/* eslint-disable max-lines-per-function */

const AnswersTypes = ({
  answersAccordion
}) => {
  const formContextDatas = React.useContext(FormContext);
  const [draggableActions, setDraggableActions] = React.useState({
    draggedFrom: null,
    draggedTo: null,
    updatedOrder: answersAccordion.actions
  });
  return /*#__PURE__*/React.createElement(React.Fragment, null, answersAccordion.actions.map((action, index) => {
    switch (action.type) {
      case 'text':
        return /*#__PURE__*/React.createElement(TypeText, {
          key: action.elementId,
          onDeleteButtonClick: onDeleteTypeButtonClick(formContextDatas.state, formContextDatas.setState, answersAccordion.accordionIdentifier),
          onDragOver: onDragOver(index, draggableActions, setDraggableActions),
          onDragStart: onDragStart(index, draggableActions, setDraggableActions),
          onDrop: onAnswersTypeDrop(draggableActions, setDraggableActions, formContextDatas.state, formContextDatas.setState, answersAccordion),
          onTextAssistantAnswerChange: onTitleTextInputChange(formContextDatas.state, formContextDatas.setState, answersAccordion.accordionIdentifier),
          textDetails: action
        });

      case 'buttons':
        return /*#__PURE__*/React.createElement(TypeButtons, {
          answersAccordionIdentifier: answersAccordion.accordionIdentifier,
          buttons: action,
          key: action.elementId,
          onAddChoiceButtonButtonClick: onAddChoicesButtonButtonClick(formContextDatas.state, formContextDatas.setState, answersAccordion.accordionIdentifier),
          onButtonsAssistantQuestionChange: onTitleButtonsInputChange(formContextDatas.state, formContextDatas.setState, answersAccordion.accordionIdentifier),
          onDeleteButtonClick: onDeleteTypeButtonClick(formContextDatas.state, formContextDatas.setState, answersAccordion.accordionIdentifier),
          onDragOver: onDragOver(index, draggableActions, setDraggableActions),
          onDragStart: onDragStart(index, draggableActions, setDraggableActions),
          onDrop: onAnswersTypeDrop(draggableActions, setDraggableActions, formContextDatas.state, formContextDatas.setState, answersAccordion)
        });

      case 'api':
        return /*#__PURE__*/React.createElement(TypeApi, {
          apiDetails: action,
          apis: formContextDatas.state.formFields.questions.apisList,
          key: action.elementId,
          onApiSelectApiNameChange: onAnswerTypeApiSelectChange(formContextDatas.state, formContextDatas.setState),
          onDeleteButtonClick: onDeleteTypeButtonClick(formContextDatas.state, formContextDatas.setState, answersAccordion.accordionIdentifier),
          onDragOver: onDragOver(index, draggableActions, setDraggableActions),
          onDragStart: onDragStart(index, draggableActions, setDraggableActions),
          onDrop: onAnswersTypeDrop(draggableActions, setDraggableActions, formContextDatas.state, formContextDatas.setState, answersAccordion)
        });

      case 'goToSkill':
        return /*#__PURE__*/React.createElement(TypeGoToSkill, {
          goToSkillDetails: action,
          goToSkills: [{
            name: 'Weather smart skills',
            value: 'weather-id'
          }, {
            name: 'Suivi de commande',
            value: 'orderId'
          }],
          key: action.elementId,
          onDeleteButtonClick: onDeleteTypeButtonClick(formContextDatas.state, formContextDatas.setState, answersAccordion.accordionIdentifier),
          onDragOver: onDragOver(index, draggableActions, setDraggableActions),
          onDragStart: onDragStart(index, draggableActions, setDraggableActions),
          onDrop: onAnswersTypeDrop(draggableActions, setDraggableActions, formContextDatas.state, formContextDatas.setState, answersAccordion),
          onGotoSkillSelectNameChange: onAnswerTypeGoToSkillSelectChange(formContextDatas.state, formContextDatas.setState)
        });

      case 'picture':
        return /*#__PURE__*/React.createElement(TypePicture, {
          key: action.elementId,
          onDeleteButtonClick: onDeleteTypeButtonClick(formContextDatas.state, formContextDatas.setState, answersAccordion.accordionIdentifier),
          onDragOver: onDragOver(index, draggableActions, setDraggableActions),
          onDragStart: onDragStart(index, draggableActions, setDraggableActions),
          onDrop: onAnswersTypeDrop(draggableActions, setDraggableActions, formContextDatas.state, formContextDatas.setState, answersAccordion),
          onPictureAnswerChange: onPictureAnswerChange(formContextDatas.state, formContextDatas.setState, answersAccordion.accordionIdentifier),
          picture: action
        });

      default:
        return /*#__PURE__*/React.createElement("p", null, "Unexpected type answer");
    }
  }));
};

var styles$e = {"type-choices__layout":"index-module_type-choices__layout__iK6Jm","type-choices__question":"index-module_type-choices__question__3atPc","choice__question":"index-module_choice__question__N5JNC","type-choices__content":"index-module_type-choices__content__Ii7--","type-choices__as":"index-module_type-choices__as__qWq7Q","choice__as":"index-module_choice__as__MtVQs","type-choices__assignment":"index-module_type-choices__assignment__fUvkf","choice__assignment":"index-module_choice__assignment__vq0Kl","type-choices__choices-container":"index-module_type-choices__choices-container__23Fmg","type-choices__choices-title":"index-module_type-choices__choices-title__1-jEU","choice__container":"index-module_choice__container__eQ9vu","choice__inputs":"index-module_choice__inputs__PNlyi","type-choices__inputs":"index-module_type-choices__inputs__5RcLQ"};

/* eslint-disable max-lines-per-function */

const ChoicesFieldSet = ({
  choices,
  onChoicesAssistantQuestionChange,
  onChoicesAssistantQuestionValueChange
}) => {
  return /*#__PURE__*/React.createElement(FieldSet, {
    className: styles$e['type-choices__content'],
    legend: "Define choices as a value"
  }, /*#__PURE__*/React.createElement("div", {
    className: styles$e['type-choices__inputs']
  }, /*#__PURE__*/React.createElement("div", {
    className: styles$e['type-choices__question']
  }, /*#__PURE__*/React.createElement(Label, {
    htmlFor: choices.titleInputName
  }, "Choices assignement title"), /*#__PURE__*/React.createElement(FieldSetInput, {
    inputIdentifier: choices.titleInputName,
    name: choices.titleInputName,
    onChange: onChoicesAssistantQuestionChange,
    placeholder: "Write a question",
    state: typeof choices.fieldsState !== 'undefined' && choices.fieldsState.titleHasError ? {
      type: 'error'
    } : undefined,
    value: choices.title
  })), /*#__PURE__*/React.createElement("span", {
    className: classNames('text-regular-base-gray-700', styles$e['type-choices__as'])
  }, "as"), /*#__PURE__*/React.createElement("div", {
    className: styles$e['type-choices__assignment']
  }, /*#__PURE__*/React.createElement(Label, {
    htmlFor: choices.assignmentInputName,
    screenReaderOnly: true
  }, "Choices assignement"), /*#__PURE__*/React.createElement(FieldSetInput, {
    inputIdentifier: choices.assignmentInputName,
    name: choices.assignmentInputName,
    onChange: onChoicesAssistantQuestionValueChange,
    placeholder: "Value",
    state: typeof choices.fieldsState !== 'undefined' && choices.fieldsState.assignmentHasError ? {
      type: 'error'
    } : undefined,
    value: choices.assignment
  }))), /*#__PURE__*/React.createElement(ErrorMessage, null, choices.errorMessage));
};

var styles$d = {"smart-skills-form-title":"index-module_smart-skills-form-title__p-2RL","smart-skills-form-title__internal-link":"index-module_smart-skills-form-title__internal-link__RC82E","smart-skills-form-title__layout-title":"index-module_smart-skills-form-title__layout-title__8h6j3"};

const Header = ({
  title
}) => {
  return /*#__PURE__*/React.createElement("div", {
    className: styles$d['smart-skills-form-title']
  }, /*#__PURE__*/React.createElement(InternalLink, {
    className: styles$d['smart-skills-form-title__internal-link'],
    path: "/smart-skills"
  }, /*#__PURE__*/React.createElement(Icon, {
    icon: "ArrowCircleLeftIcon"
  })), /*#__PURE__*/React.createElement(PageLayoutTitle, {
    className: styles$d['smart-skills-form-title__layout-title']
  }, title));
};

var styles$c = {"questions__element":"index-module_questions__element__T5wjZ","questions__drag-and-drop":"index-module_questions__drag-and-drop__z49l4","questions__drag-and-drop--empty":"index-module_questions__drag-and-drop--empty__WYSHC","questions__content-info":"index-module_questions__content-info__1-57L","questions__empty-questions":"index-module_questions__empty-questions__0meXi","questions__empty-questions-error":"index-module_questions__empty-questions-error__fiamZ","questions__empty-questions-error--hidden":"index-module_questions__empty-questions-error--hidden__JAYAI"};

/* eslint-disable react-hooks/exhaustive-deps */

const Questions = ({
  questions
}) => {
  const formContextDatas = React.useContext(FormContext);
  const onChoicesAddButtonClick$1 = onChoicesAddButtonClick(formContextDatas.state, formContextDatas.setState);
  const onFreeInputAddButtonClick$1 = onFreeInputAddButtonClick(formContextDatas.state, formContextDatas.setState);
  const onApiAddButtonClick$1 = onApiAddButtonClick(formContextDatas.state, formContextDatas.setState);
  return /*#__PURE__*/React.createElement(PageLayoutContent, null, /*#__PURE__*/React.createElement(PageLayoutContentTitle, null, "Questions"), /*#__PURE__*/React.createElement(PageLayoutContentDescribe, null, "Define your assistant's questions"), /*#__PURE__*/React.createElement(React.Fragment, null, /*#__PURE__*/React.createElement(DragAndDrop // eslint-disable-next-line @typescript-eslint/no-unsafe-argument
  , {
    // eslint-disable-next-line @typescript-eslint/no-unsafe-argument
    className: classNames(styles$c['questions__drag-and-drop'], {
      [styles$c['questions__drag-and-drop--empty']]: genericUtils.isEmpty(questions.fields)
    }),
    dragAndDropGroupIdentifier: "questionType"
  }, /*#__PURE__*/React.createElement(QuestionsTypes, null)), genericUtils.isEmpty(questions.fields) && /*#__PURE__*/React.createElement("div", {
    className: styles$c['questions__content-info']
  }, /*#__PURE__*/React.createElement("p", {
    className: classNames('text-italic-base-dark', // eslint-disable-next-line @typescript-eslint/no-unsafe-argument
    styles$c['questions__empty-questions'])
  }, "No question elements (required)"), /*#__PURE__*/React.createElement("div", {
    className: classNames({
      [styles$c['questions__empty-questions-error--hidden']]: typeof questions.errorMessage === 'undefined'
    })
  }, /*#__PURE__*/React.createElement("strong", {
    className: classNames('text-regular-sm-danger-500', // eslint-disable-next-line @typescript-eslint/no-unsafe-argument
    styles$c['questions__empty-questions-error'], {
      [styles$c['questions__empty-questions-error--hidden']]: typeof questions.errorMessage === 'undefined'
    })
  }, questions.errorMessage))), /*#__PURE__*/React.createElement("p", {
    className: classNames('text-regular-base-dark', // eslint-disable-next-line @typescript-eslint/no-unsafe-argument
    styles$c.questions__element)
  }, "Add element"), /*#__PURE__*/React.createElement(ButtonGroup, null, /*#__PURE__*/React.createElement(ButtonGroupButton, {
    icon: {
      name: 'ShareIcon'
    },
    onClick: onChoicesAddButtonClick$1
  }, "Choices"), /*#__PURE__*/React.createElement(ButtonGroupButton, {
    icon: {
      name: 'ChatIcon'
    },
    onClick: onFreeInputAddButtonClick$1
  }, "Free Input"), /*#__PURE__*/React.createElement(ButtonGroupButton, {
    icon: {
      name: 'DatabaseIcon'
    },
    isDisabled: genericUtils.isEmpty(questions.apisList),
    onClick: onApiAddButtonClick$1
  }, "API ", /*#__PURE__*/React.createElement("span", {
    className: "sr-only"
  }, "questions")))));
};

var styles$b = {"choices-button__question":"index-module_choices-button__question__xmpKi","choices-button__as":"index-module_choices-button__as__AvxBo","choices-button__assignment":"index-module_choices-button__assignment__DyH1a","choices-button__container":"index-module_choices-button__container__2gMbL","choices-button__inputs":"index-module_choices-button__inputs__ipd6V","choices-button__delete-container--hidden":"index-module_choices-button__delete-container--hidden__GlgyQ"};

const QuestionsChoicesButton = ({
  choicesButton,
  onDeleteButtonClick,
  onChoicesButtonTitleChange,
  onChoicesButtonAssignmentChange,
  onDragOver,
  onDragStart,
  onDrop,
  position
}) => {
  return /*#__PURE__*/React.createElement(DragAndDropListItem, {
    isInline: true,
    key: choicesButton.titleInputName,
    onDragOver: onDragOver,
    onDragStart: onDragStart,
    onDrop: onDrop
  }, /*#__PURE__*/React.createElement("div", {
    className: styles$b['choices-button__container']
  }, /*#__PURE__*/React.createElement("div", {
    className: styles$b['choices-button__inputs']
  }, /*#__PURE__*/React.createElement("div", {
    className: styles$b['choices-button__question']
  }, /*#__PURE__*/React.createElement(Label, {
    htmlFor: choicesButton.titleInputName,
    screenReaderOnly: true
  }, "Questions choices button title"), /*#__PURE__*/React.createElement(FieldSetInput, {
    inputIdentifier: choicesButton.titleInputName,
    name: choicesButton.titleInputName,
    onChange: onChoicesButtonTitleChange,
    placeholder: "Choice",
    state: typeof choicesButton.fieldsState !== 'undefined' && choicesButton.fieldsState.titleHasError ? {
      type: 'error'
    } : undefined,
    value: choicesButton.title
  })), /*#__PURE__*/React.createElement("span", {
    className: classNames('text-regular-base-gray-700', // eslint-disable-next-line @typescript-eslint/no-unsafe-argument
    styles$b['choices-button__as'])
  }, "as"), /*#__PURE__*/React.createElement("div", {
    className: styles$b['choices-button__assignment']
  }, /*#__PURE__*/React.createElement(Label, {
    htmlFor: choicesButton.assignmentInputName,
    screenReaderOnly: true
  }, "Questions choices button assignment"), /*#__PURE__*/React.createElement(FieldSetInput, {
    inputIdentifier: choicesButton.assignmentInputName,
    name: choicesButton.assignmentInputName,
    onChange: onChoicesButtonAssignmentChange,
    placeholder: "Value",
    state: typeof choicesButton.fieldsState !== 'undefined' && choicesButton.fieldsState.assignmentHasError ? {
      type: 'error'
    } : undefined,
    value: choicesButton.assignment
  }))), /*#__PURE__*/React.createElement("div", {
    className: classNames({
      [styles$b['choices-button__delete-container--hidden']]: position === genericUtils.ARRAY.FIRST_INDEX
    })
  }, /*#__PURE__*/React.createElement(Button, {
    icon: {
      border: 'none',
      name: 'TrashIcon'
    },
    isOutlined: true,
    name: choicesButton.elementId,
    onClick: onDeleteButtonClick,
    type: "button"
  }))));
};

const QuestionsTypes = () => {
  const formContextDatas = React.useContext(FormContext);
  const [draggableQuestions, setDraggableQuestions] = React.useState({
    draggedFrom: null,
    draggedTo: null,
    updatedOrder: formContextDatas.state.formFields.questions.fields
  });
  return /*#__PURE__*/React.createElement(React.Fragment, null, formContextDatas.state.formFields.questions.fields.map((question, index) => {
    switch (question.type) {
      case 'api':
        return /*#__PURE__*/React.createElement(TypeApi, {
          apiDetails: question,
          apis: formContextDatas.state.formFields.questions.apisList,
          key: question.elementId,
          onApiSelectApiNameChange: onQuestionTypeApiSelectChange(formContextDatas.state, formContextDatas.setState),
          onDeleteButtonClick: onDeleteButtonClick(formContextDatas.state, formContextDatas.setState),
          onDragOver: onDragOver(index, draggableQuestions, setDraggableQuestions),
          onDragStart: onDragStart(index, draggableQuestions, setDraggableQuestions),
          onDrop: onQuestionsTypeDrop(draggableQuestions, setDraggableQuestions, formContextDatas.state, formContextDatas.setState)
        });

      case 'free-input':
        return /*#__PURE__*/React.createElement(TypeFreeInput, {
          freeInput: question,
          key: question.elementId,
          onDeleteButtonClick: onDeleteButtonClick(formContextDatas.state, formContextDatas.setState),
          onDragOver: onDragOver(index, draggableQuestions, setDraggableQuestions),
          onDragStart: onDragStart(index, draggableQuestions, setDraggableQuestions),
          onDrop: onQuestionsTypeDrop(draggableQuestions, setDraggableQuestions, formContextDatas.state, formContextDatas.setState),
          onFreeInputAssignmentChange: onFreeInputInputsChange(question.elementId, formContextDatas.state, formContextDatas.setState),
          onFreeInputRegexChange: onFreeInputInputsChange(question.elementId, formContextDatas.state, formContextDatas.setState),
          onFreeInputSelectNameChange: onTypeFreeInputSelectChange(formContextDatas.state, formContextDatas.setState),
          onFreeInputTitleChange: onFreeInputInputsChange(question.elementId, formContextDatas.state, formContextDatas.setState)
        });

      case 'choices':
        return /*#__PURE__*/React.createElement(TypeChoices, {
          choices: question,
          key: question.elementId,
          onChoicesAddButtonClick: onAddChoicesButtonClick(formContextDatas.state, formContextDatas.setState),
          onChoicesAssistantQuestionChange: onChoicesInputsChange(formContextDatas.state, formContextDatas.setState),
          onChoicesAssistantQuestionValueChange: onChoicesInputsChange(formContextDatas.state, formContextDatas.setState),
          onDeleteButtonClick: onDeleteButtonClick(formContextDatas.state, formContextDatas.setState),
          onDragOver: onDragOver(index, draggableQuestions, setDraggableQuestions),
          onDragStart: onDragStart(index, draggableQuestions, setDraggableQuestions),
          onDrop: onQuestionsTypeDrop(draggableQuestions, setDraggableQuestions, formContextDatas.state, formContextDatas.setState)
        });

      default:
        return /*#__PURE__*/React.createElement("p", null, "Unexpected type question");
    }
  }));
};

var styles$a = {"scenario":"index-module_scenario__tahV3","scenario__title":"index-module_scenario__title__iwz7j","scenario__title--conditions":"index-module_scenario__title--conditions__yDHvs","scenario__field-set":"index-module_scenario__field-set__1uFCJ"};

/* eslint-disable @typescript-eslint/no-unsafe-argument */

const Scenario = ({
  answersAccordionId,
  scenarioConditionsField
}) => {
  const formContextDatas = React.useContext(FormContext);
  const onDeleteConditionLineButtonClick = onDeleteScenarioConditionButtonClick(formContextDatas.state, formContextDatas.setState, answersAccordionId);
  const onAddScenarioConditionButtonClick$1 = onAddScenarioConditionButtonClick(formContextDatas.state, formContextDatas.setState);
  const onScenarioConditionMatchInputChange$1 = onScenarioConditionMatchInputChange(formContextDatas.state, formContextDatas.setState, answersAccordionId);
  const onScenarioConditionMatchSelectChange = onScenarioConditionSelectsChange(formContextDatas.state, formContextDatas.setState, answersAccordionId);
  const onScenarioConditionOperatorSelectChange = onScenarioConditionSelectsChange(formContextDatas.state, formContextDatas.setState, answersAccordionId);
  const onScenarioConditionTargetSelectChange = onScenarioConditionSelectsChange(formContextDatas.state, formContextDatas.setState, answersAccordionId);
  return /*#__PURE__*/React.createElement("section", {
    className: styles$a.scenario
  }, /*#__PURE__*/React.createElement("h3", {
    className: classNames('label-regular-sm-gray-600', styles$a.scenario__title, styles$a['scenario__title--conditions'])
  }, "conditions"), /*#__PURE__*/React.createElement(FieldSet, {
    className: styles$a['scenario__field-set'],
    legend: "Conditionnal answer setup"
  }, /*#__PURE__*/React.createElement(React.Fragment, null, scenarioConditionsField.scenarioConditions.map(scenarioCondition => {
    return /*#__PURE__*/React.createElement(ScenarioCondition, {
      key: scenarioCondition.elementId,
      onDeleteScenarioConditionButtonClick: onDeleteConditionLineButtonClick,
      onScenarioConditionMatchInputChange: onScenarioConditionMatchInputChange$1,
      onScenarioConditionMatchSelectChange: onScenarioConditionMatchSelectChange,
      onScenarioConditionOperatorSelectChange: onScenarioConditionOperatorSelectChange,
      onScenarioConditionTargetSelectChange: onScenarioConditionTargetSelectChange,
      scenarioCondition: scenarioCondition,
      scenarioConditionTargetOptions: formContextDatas.state.formFields.answers.scenarioConditionTargetOptions
    });
  })), /*#__PURE__*/React.createElement(ErrorMessage, null, scenarioConditionsField.errorMessage)), /*#__PURE__*/React.createElement(Button, {
    icon: {
      name: 'PlusIcon',
      position: 'left-icon'
    },
    isOutlined: true,
    name: answersAccordionId,
    onClick: onAddScenarioConditionButtonClick$1,
    type: "button"
  }, "Add condition"));
};

var styles$9 = {"scenario-condition":"index-module_scenario-condition__-vKxi","scenario-condition__statement":"index-module_scenario-condition__statement__N4Vs6","scenario-condition__select-input-value":"index-module_scenario-condition__select-input-value__zkgJl","scenario-condition__select-operator":"index-module_scenario-condition__select-operator__9C5pC","scenario-condition__input-conditionnal-value":"index-module_scenario-condition__input-conditionnal-value__q0AT1","scenario-condition__input-conditionnal-value--hidden":"index-module_scenario-condition__input-conditionnal-value--hidden__fWKsx"};

/* eslint-disable complexity */

const ScenarioCondition = ({
  scenarioCondition,
  onScenarioConditionMatchInputChange,
  onScenarioConditionMatchSelectChange,
  onScenarioConditionOperatorSelectChange,
  onScenarioConditionTargetSelectChange,
  onDeleteScenarioConditionButtonClick,
  scenarioConditionTargetOptions
}) => {
  const operators = [{
    displayedValue: '=',
    value: 'equal'
  }, {
    displayedValue: 'exist',
    value: 'exist'
  }];
  const freeInputOptionList = scenarioConditionTargetOptions.filter(option => option.type === 'free-input');
  const customerApiOptionList = scenarioConditionTargetOptions.filter(option => option.type === 'customer-api');
  const choicesOptionList = scenarioConditionTargetOptions.filter(option => option.type === 'choices');
  return /*#__PURE__*/React.createElement("div", {
    className: styles$9['scenario-condition']
  }, /*#__PURE__*/React.createElement("span", {
    className: classNames('text-regular-base-gray-700', styles$9['scenario-condition__statement'])
  }, scenarioCondition.statement), /*#__PURE__*/React.createElement("div", {
    className: styles$9['scenario-condition__select-input-value']
  }, /*#__PURE__*/React.createElement(Label, {
    htmlFor: scenarioCondition.targetSelectName,
    screenReaderOnly: true
  }, "Scenario condition target"), /*#__PURE__*/React.createElement(FieldSetInputSelect, {
    defaultText: genericUtils.isEmpty(scenarioConditionTargetOptions) || typeof scenarioCondition.target === 'undefined' ? 'Select input' : undefined,
    inputIdentifier: scenarioCondition.targetSelectName,
    isDisabled: genericUtils.isEmpty(scenarioConditionTargetOptions),
    onChange: onScenarioConditionTargetSelectChange(scenarioCondition.targetSelectName),
    state: typeof scenarioCondition.scenarioConditionState !== 'undefined' && scenarioCondition.scenarioConditionState.targetHasError ? {
      type: 'error'
    } : undefined,
    title: typeof scenarioCondition.target === 'undefined' ? undefined : scenarioCondition.target.replace(/^(?:[\0-\t\x0B\f\x0E-\u2027\u202A-\uD7FF\uE000-\uFFFF]|[\uD800-\uDBFF][\uDC00-\uDFFF]|[\uD800-\uDBFF](?![\uDC00-\uDFFF])|(?:[^\uD800-\uDBFF]|^)[\uDC00-\uDFFF])*\|customer\x2Dapi\||free\x2Dinput\||choices\|/, ''),
    value: scenarioCondition.target
  }, /*#__PURE__*/React.createElement(React.Fragment, null, !genericUtils.isEmpty(freeInputOptionList) && /*#__PURE__*/React.createElement("optgroup", {
    label: "Text"
  }, freeInputOptionList.map(freeInputOption => {
    return /*#__PURE__*/React.createElement(Option, {
      key: freeInputOption.elementId,
      value: freeInputOption.value
    }, freeInputOption.displayedValue);
  })), !genericUtils.isEmpty(customerApiOptionList) && /*#__PURE__*/React.createElement("optgroup", {
    label: "Api"
  }, customerApiOptionList.map(customerApiOption => {
    return /*#__PURE__*/React.createElement(Option, {
      key: customerApiOption.elementId,
      value: customerApiOption.value
    }, customerApiOption.displayedValue);
  })), !genericUtils.isEmpty(choicesOptionList) && /*#__PURE__*/React.createElement("optgroup", {
    label: "Choices"
  }, choicesOptionList.map(choicesOption => {
    return /*#__PURE__*/React.createElement(Option, {
      key: choicesOption.elementId,
      value: choicesOption.value
    }, choicesOption.displayedValue);
  }))))), /*#__PURE__*/React.createElement("div", {
    className: styles$9['scenario-condition__select-operator']
  }, /*#__PURE__*/React.createElement(Label, {
    htmlFor: scenarioCondition.operatorSelectName,
    screenReaderOnly: true
  }, "Scenario condition operator"), /*#__PURE__*/React.createElement(FieldSetInputSelect, {
    inputIdentifier: scenarioCondition.operatorSelectName,
    onChange: onScenarioConditionOperatorSelectChange(scenarioCondition.operatorSelectName),
    value: scenarioCondition.operator
  }, operators.map(operator => {
    return /*#__PURE__*/React.createElement(Option, {
      key: operator.value,
      value: operator.value
    }, operator.displayedValue);
  }))), /*#__PURE__*/React.createElement("div", {
    className: classNames(styles$9['scenario-condition__input-conditionnal-value'], {
      [styles$9['scenario-condition__input-conditionnal-value--hidden']]: typeof scenarioCondition.matchInputName === 'undefined'
    })
  }, typeof scenarioCondition.matchInputName !== 'undefined' && /*#__PURE__*/React.createElement(React.Fragment, null, /*#__PURE__*/React.createElement(Label, {
    htmlFor: typeof scenarioCondition.matchInputName === 'undefined' ? '' : scenarioCondition.matchInputName,
    screenReaderOnly: true
  }, "Scenario condition match"), typeof scenarioCondition.target !== 'undefined' && scenarioCondition.target.includes('choices|') ? /*#__PURE__*/React.createElement(FieldSetInputSelect, {
    defaultText: genericUtils.isEmpty(scenarioCondition.matchOptions) || typeof scenarioCondition.match === 'undefined' ? 'Select input' : undefined,
    inputIdentifier: scenarioCondition.matchInputName,
    onChange: onScenarioConditionMatchSelectChange(scenarioCondition.matchInputName),
    state: typeof scenarioCondition.scenarioConditionState !== 'undefined' && scenarioCondition.scenarioConditionState.matchHasError ? {
      type: 'error'
    } : undefined,
    value: scenarioCondition.match
  }, scenarioCondition.matchOptions.map(matchOption => {
    return /*#__PURE__*/React.createElement("option", {
      key: matchOption.identifier,
      value: matchOption.value
    }, matchOption.displayedValue);
  })) : /*#__PURE__*/React.createElement(FieldSetInput, {
    inputIdentifier: scenarioCondition.matchInputName,
    name: scenarioCondition.matchInputName,
    onChange: onScenarioConditionMatchInputChange,
    placeholder: "Value",
    state: typeof scenarioCondition.scenarioConditionState !== 'undefined' && scenarioCondition.scenarioConditionState.matchHasError ? {
      type: 'error'
    } : undefined,
    value: typeof scenarioCondition.match === 'undefined' ? '' : scenarioCondition.match
  }))), scenarioCondition.statement !== 'if' && /*#__PURE__*/React.createElement(Button, {
    icon: {
      border: 'none',
      name: 'TrashIcon'
    },
    isOutlined: true,
    name: scenarioCondition.elementId,
    onClick: onDeleteScenarioConditionButtonClick,
    type: "button"
  }));
};

var styles$8 = {"smart-skills-form-setup__input-name":"index-module_smart-skills-form-setup__input-name__iDmhR","smart-skills-form-setup":"index-module_smart-skills-form-setup__7Rnlb"};

const Setup = ({
  setup
}) => {
  const formContextDatas = React.useContext(FormContext);
  const onSmartSkillNameChange = onSetupTitleInputChange(formContextDatas.state, formContextDatas.setState);
  return /*#__PURE__*/React.createElement(PageLayoutContent, null, /*#__PURE__*/React.createElement(PageLayoutContentTitle, {
    className: styles$8['smart-skills-form-setup']
  }, "Setup"), /*#__PURE__*/React.createElement("div", {
    className: styles$8['smart-skills-form-setup__input-name']
  }, /*#__PURE__*/React.createElement(Input, {
    label: "Smart skill name*",
    name: setup.titleInputName,
    onChange: onSmartSkillNameChange,
    placeholder: "Smart skill name",
    state: typeof setup.errorMessage === 'undefined' ? undefined : {
      message: setup.errorMessage,
      type: 'error'
    },
    value: setup.title
  })));
};

var styles$7 = {"smart-skills-content":"index-module_smart-skills-content__snRUt","smart-skills-content__button-container":"index-module_smart-skills-content__button-container__ZEj-a","smart-skills-content__button":"index-module_smart-skills-content__button__uz8qI"};

const SmartSkillsForm = ({
  state,
  onSubmit
}) => {
  const formContextDatas = React.useContext(FormContext);
  return /*#__PURE__*/React.createElement(React.Fragment, null, /*#__PURE__*/React.createElement(Header, {
    title: state.title
  }), /*#__PURE__*/React.createElement("form", {
    className: styles$7['smart-skills-content'],
    onSubmit: onSubmit
  }, /*#__PURE__*/React.createElement(Setup, {
    setup: formContextDatas.state.formFields.setup
  }), /*#__PURE__*/React.createElement(Questions, {
    questions: formContextDatas.state.formFields.questions
  }), /*#__PURE__*/React.createElement(Answers, {
    answers: formContextDatas.state.formFields.answers
  }), /*#__PURE__*/React.createElement("div", {
    className: styles$7['smart-skills-content__button-container']
  }, /*#__PURE__*/React.createElement(Button, {
    className: styles$7['smart-skills-content__button'],
    isBlock: true,
    isDisabled: state.formState.isLoading,
    isLoading: state.formState.isLoading,
    type: "submit"
  }, "Save"))));
};

const SmartSkillsFormViewer = ({
  botId,
  createOneSmartSkill,
  getOneSmartSkillFormDetails,
  getOneSmartSkillsInfos,
  history,
  updateOneSmartSkill
}) => {
  const [state, setState] = React.useState({
    type: 'loading'
  });
  const value = React.useMemo(() => {
    return {
      setState,
      state: state
    };
  }, [state]);
  const [feedback, setFeedback] = React.useState(null);
  React.useEffect(() => {
    void onInit(botId, history, setState, getOneSmartSkillsInfos, getOneSmartSkillFormDetails);
    return () => {
      setFeedback(null);
    };
  }, [botId, getOneSmartSkillsInfos, getOneSmartSkillFormDetails, history]);
  return /*#__PURE__*/React.createElement(PageLayout, null, /*#__PURE__*/React.createElement(React.Fragment, null, feedback !== null && /*#__PURE__*/React.createElement(Toast, {
    autoHide: {
      isActive: true,
      onHide: onToastHide(setFeedback)
    },
    position: {
      location: 'bottom-left'
    },
    type: feedback.type
  }, feedback.message), state.type === 'form' && /*#__PURE__*/React.createElement(FormContext.Provider, {
    value: value
  }, /*#__PURE__*/React.createElement(SmartSkillsForm, {
    onSubmit: onSubmit(botId, state, setState, setFeedback, createOneSmartSkill, updateOneSmartSkill),
    state: state
  })), state.type === 'loading' && /*#__PURE__*/React.createElement(PageLayoutLoading, null), state.type === 'error' && /*#__PURE__*/React.createElement(PageLayoutError, {
    buttonText: "Retry",
    message: state.message,
    onButtonClick: onRetryButtonClick(botId, history, setState, getOneSmartSkillsInfos, getOneSmartSkillFormDetails)
  })));
};

var styles$6 = {"type-api__select":"index-module_type-api__select__1TrV9","type-api__list-item-icon":"index-module_type-api__list-item-icon__hzPLW","type-api__list-item":"index-module_type-api__list-item__cmTOY","type-api__lists":"index-module_type-api__lists__ANmNr","type-api__list-empty":"index-module_type-api__list-empty__h1rnT","type-api__inputs-list":"index-module_type-api__inputs-list__ygtcL","type-api__content":"index-module_type-api__content__rindm"};

/* eslint-disable max-lines-per-function */

const TypeApi = ({
  apiDetails,
  apis,
  onApiSelectApiNameChange,
  onDeleteButtonClick,
  onDragOver,
  onDragStart,
  onDrop
}) => {
  const optionGroupGetApi = apis.filter(api => api.method === 'GET');
  const optionGroupPostApi = apis.filter(api => api.method === 'POST');
  return /*#__PURE__*/React.createElement(DragAndDropListItem, {
    deleteButton: {
      name: apiDetails.elementId,
      onDeleteButtonClick
    },
    onDragOver: onDragOver,
    onDragStart: onDragStart,
    onDrop: onDrop,
    title: "API"
  }, /*#__PURE__*/React.createElement("div", {
    className: styles$6['type-api__content']
  }, /*#__PURE__*/React.createElement("div", {
    className: styles$6['type-api__select']
  }, /*#__PURE__*/React.createElement(Select, {
    defaultText: typeof apiDetails.apiId === 'undefined' ? 'Select an API' : undefined,
    label: "api name",
    onChange: onApiSelectApiNameChange(apiDetails.nameSelectName),
    state: typeof apiDetails.apiNameSelectErrorMessage === 'undefined' ? undefined : {
      message: apiDetails.apiNameSelectErrorMessage,
      type: 'error'
    },
    value: apiDetails.apiId
  }, /*#__PURE__*/React.createElement("optgroup", {
    label: "GET"
  }, optionGroupGetApi.map(api => {
    return /*#__PURE__*/React.createElement(Option, {
      key: genericUtils.generateRandomTagId(),
      value: api.value
    }, api.name);
  })), /*#__PURE__*/React.createElement("optgroup", {
    label: "POST"
  }, optionGroupPostApi.map(api => {
    return /*#__PURE__*/React.createElement(Option, {
      key: genericUtils.generateRandomTagId(),
      value: api.value
    }, api.name);
  })))), typeof apiDetails.apiId !== 'undefined' && /*#__PURE__*/React.createElement("div", {
    className: styles$6['type-api__lists']
  }, /*#__PURE__*/React.createElement(List, {
    className: styles$6['type-api__inputs-list'],
    title: "Input values"
  }, /*#__PURE__*/React.createElement(React.Fragment, null, genericUtils.isEmpty(apiDetails.inputValues) && /*#__PURE__*/React.createElement(ListItemWithEmptyBullet, {
    className: styles$6['type-api__list-empty']
  }, "Empty"), apiDetails.inputValues.map(inputValue => {
    return /*#__PURE__*/React.createElement(ListItemWithIcon, {
      className: styles$6['type-api__list-item'],
      icon: {
        className: styles$6['type-api__list-item-icon'],
        name: 'BookmarkIcon'
      },
      key: `${inputValue.name} - ${genericUtils.generateUniqueId()}`
    }, inputValue.name);
  }))), /*#__PURE__*/React.createElement(List, {
    title: "Outputs values"
  }, /*#__PURE__*/React.createElement(React.Fragment, null, genericUtils.isEmpty(apiDetails.outputs) && /*#__PURE__*/React.createElement(ListItemWithEmptyBullet, {
    className: styles$6['type-api__list-empty']
  }, "Empty"), apiDetails.outputs.map(output => {
    return /*#__PURE__*/React.createElement(ListItemWithIcon, {
      className: styles$6['type-api__list-item'],
      icon: {
        className: styles$6['type-api__list-item-icon'],
        name: 'BookmarkIcon'
      },
      key: `${output.name} - ${genericUtils.generateUniqueId()}`
    }, output.name);
  }))))));
};

var styles$5 = {"type-buttons__assistant-answer":"index-module_type-buttons__assistant-answer__Lp-xl","type-buttons__layout":"index-module_type-buttons__layout__TQyvu","type-buttons__buttons-container":"index-module_type-buttons__buttons-container__ir8AF","type-buttons__buttons-title":"index-module_type-buttons__buttons-title__Vsvmv"};

/* eslint-disable @typescript-eslint/no-unsafe-argument */

const TypeButtons = ({
  buttons,
  onButtonsAssistantQuestionChange,
  onAddChoiceButtonButtonClick,
  onDeleteButtonClick,
  onDragOver: onDragOver$1,
  onDragStart: onDragStart$1,
  onDrop,
  answersAccordionIdentifier
}) => {
  const formContextDatas = React.useContext(FormContext);
  const [draggableChoicesButton, setDraggableChoicesButton] = React.useState({
    draggedFrom: null,
    draggedTo: null,
    updatedOrder: buttons.choicesButtonsFields.choicesButtons
  });
  return /*#__PURE__*/React.createElement(DragAndDropListItem, {
    deleteButton: {
      name: buttons.elementId,
      onDeleteButtonClick
    },
    onDragOver: onDragOver$1,
    onDragStart: onDragStart$1,
    onDrop: onDrop,
    title: "Buttons"
  }, /*#__PURE__*/React.createElement("div", {
    className: styles$5['type-buttons__layout']
  }, /*#__PURE__*/React.createElement(Input, {
    className: styles$5['type-buttons__assistant-answer'],
    label: "Assistant answer",
    name: buttons.titleInputName,
    onChange: onButtonsAssistantQuestionChange,
    placeholder: "Insert assistant answer",
    state: typeof buttons.errorMessage === 'undefined' ? undefined : {
      message: buttons.errorMessage,
      type: 'error'
    },
    value: buttons.title
  }), /*#__PURE__*/React.createElement("div", {
    className: styles$5['type-buttons__buttons-container']
  }, /*#__PURE__*/React.createElement("span", {
    className: classNames('label-regular-sm-gray-600', styles$5['type-buttons__buttons-title'])
  }, "buttons"), /*#__PURE__*/React.createElement(FieldSet, {
    legend: "Define question as a value"
  }, /*#__PURE__*/React.createElement(DragAndDrop, {
    dragAndDropGroupIdentifier: `${answersAccordionIdentifier}${buttons.elementId}`
  }, buttons.choicesButtonsFields.choicesButtons.map((choicesButton, index) => {
    return /*#__PURE__*/React.createElement(AnswersChoicesButton, {
      choicesButton: choicesButton,
      key: choicesButton.elementId,
      onChoiceButtonInputsChange: onChoicesButtonInputsChange$1(formContextDatas.state, formContextDatas.setState, answersAccordionIdentifier),
      onChoiceButtonQuestionAndAnswerSelectChange: onChoicesButtonSelectsChange(formContextDatas.state, formContextDatas.setState, answersAccordionIdentifier),
      onChoiceButtonTypeSelectChange: onChoicesButtonSelectsChange(formContextDatas.state, formContextDatas.setState, answersAccordionIdentifier),
      onDeleteChoiceButtonButtonClick: onDeleteChoicesButtonButtonClick(buttons.choicesButtonsFields, formContextDatas.state, formContextDatas.setState, answersAccordionIdentifier),
      onDragOver: onDragOver(index, draggableChoicesButton, setDraggableChoicesButton),
      onDragStart: onDragStart(index, draggableChoicesButton, setDraggableChoicesButton),
      onDrop: onAnswersChoicesButtonDrop(draggableChoicesButton, setDraggableChoicesButton, buttons.elementId, formContextDatas.state, formContextDatas.setState, answersAccordionIdentifier),
      position: index,
      questionsAndAnswers: formContextDatas.state.formFields.questionsAndAnswers
    });
  })), /*#__PURE__*/React.createElement(ErrorMessage, null, buttons.choicesButtonsFields.errorMessage)), /*#__PURE__*/React.createElement("div", null, /*#__PURE__*/React.createElement(Button, {
    icon: {
      name: 'PlusIcon',
      position: 'left-icon'
    },
    isOutlined: true,
    name: buttons.elementId,
    onClick: onAddChoiceButtonButtonClick,
    type: "button"
  }, "Add choice")))));
};

var styles$4 = {"type-choices__layout":"index-module_type-choices__layout__uRwn-","type-choices__question":"index-module_type-choices__question__addHr","choice__question":"index-module_choice__question__tJmdQ","type-choices__content":"index-module_type-choices__content__QLYFB","type-choices__as":"index-module_type-choices__as__XBCPT","choice__as":"index-module_choice__as__3nxIp","type-choices__assignment":"index-module_type-choices__assignment__Zb0r9","choice__assignment":"index-module_choice__assignment__Gtbdu","type-choices__choices-container":"index-module_type-choices__choices-container__-jYNQ","type-choices__choices-title":"index-module_type-choices__choices-title__s-gmF","choice__container":"index-module_choice__container__b6hzP","choice__inputs":"index-module_choice__inputs__Xsx7K","type-choices__inputs":"index-module_type-choices__inputs__rV4qL"};

/* eslint-disable max-lines-per-function */

const TypeChoices = ({
  choices,
  onChoicesAddButtonClick,
  onChoicesAssistantQuestionChange,
  onChoicesAssistantQuestionValueChange,
  onDeleteButtonClick,
  onDragOver: onDragOver$1,
  onDragStart: onDragStart$1,
  onDrop
}) => {
  const formContextDatas = React.useContext(FormContext);
  const [draggableChoices, setDraggableChoices] = React.useState({
    draggedFrom: null,
    draggedTo: null,
    updatedOrder: choices.choicesField.choicesButtons
  });
  return /*#__PURE__*/React.createElement(DragAndDropListItem, {
    deleteButton: {
      name: choices.elementId,
      onDeleteButtonClick
    },
    onDragOver: onDragOver$1,
    onDragStart: onDragStart$1,
    onDrop: onDrop,
    title: "Choices"
  }, /*#__PURE__*/React.createElement("div", {
    className: styles$4['type-choices__layout']
  }, /*#__PURE__*/React.createElement(ChoicesFieldSet, {
    choices: choices,
    onChoicesAssistantQuestionChange: onChoicesAssistantQuestionChange,
    onChoicesAssistantQuestionValueChange: onChoicesAssistantQuestionValueChange
  }), /*#__PURE__*/React.createElement("div", {
    className: styles$4['type-choices__choices-container']
  }, /*#__PURE__*/React.createElement("span", {
    className: classNames('label-regular-sm-gray-600', styles$4['type-choices__choices-title'])
  }, "choices"), /*#__PURE__*/React.createElement(FieldSet, {
    hasError: typeof choices.choicesField.errorMessage === 'string',
    legend: "Define question as a value"
  }, /*#__PURE__*/React.createElement(DragAndDrop, {
    dragAndDropGroupIdentifier: choices.elementId
  }, choices.choicesField.choicesButtons.map((choicesButton, index) => {
    return /*#__PURE__*/React.createElement(QuestionsChoicesButton, {
      choicesButton: choicesButton,
      key: choicesButton.elementId,
      onChoicesButtonAssignmentChange: onChoicesButtonInputsChange(choices.elementId, formContextDatas.state, formContextDatas.setState),
      onChoicesButtonTitleChange: onChoicesButtonInputsChange(choices.elementId, formContextDatas.state, formContextDatas.setState),
      onDeleteButtonClick: onDeleteButtonClick$1(choices.choicesField, choices.elementId, formContextDatas.state, formContextDatas.setState),
      onDragOver: onDragOver(index, draggableChoices, setDraggableChoices),
      onDragStart: onDragStart(index, draggableChoices, setDraggableChoices),
      onDrop: onChoicesButtonsDrop(draggableChoices, setDraggableChoices, choices.elementId, formContextDatas.state, formContextDatas.setState),
      position: index
    });
  })), /*#__PURE__*/React.createElement(ErrorMessage, null, choices.choicesField.errorMessage)), /*#__PURE__*/React.createElement("div", null, /*#__PURE__*/React.createElement(Button, {
    icon: {
      name: 'PlusIcon',
      position: 'left-icon'
    },
    isOutlined: true,
    name: choices.elementId,
    onClick: onChoicesAddButtonClick,
    type: "button"
  }, "Add choice")))));
};

var styles$3 = {"type-free-input__container":"index-module_type-free-input__container__6vMT0","type-free-input__content":"index-module_type-free-input__content__avj6T","type-free-input__question":"index-module_type-free-input__question__tq8Sx","type-free-input__as":"index-module_type-free-input__as__QABg4","type-free-input__validation":"index-module_type-free-input__validation__Ykm4V","type-free-input__select-validation":"index-module_type-free-input__select-validation__tLTL4","type-free-input__input-regex":"index-module_type-free-input__input-regex__HV52V","type-free-input__inputs":"index-module_type-free-input__inputs__YFV5T","type-free-input__assignment":"index-module_type-free-input__assignment__BKE0L"};

/* eslint-disable @typescript-eslint/no-unsafe-argument */

const TypeFreeInput = ({
  freeInput,
  onFreeInputTitleChange,
  onFreeInputAssignmentChange,
  onDeleteButtonClick,
  onDragOver,
  onDragStart,
  onDrop,
  onFreeInputSelectNameChange,
  onFreeInputRegexChange
}) => {
  const freeInputSelectOptions = [{
    name: 'None',
    value: 'none'
  }, {
    name: 'Email',
    value: 'email'
  }, {
    name: 'Phone Number',
    value: 'phone-number'
  }, {
    name: 'Custom',
    value: 'custom'
  }];
  return /*#__PURE__*/React.createElement(DragAndDropListItem, {
    deleteButton: {
      name: freeInput.elementId,
      onDeleteButtonClick
    },
    onDragOver: onDragOver,
    onDragStart: onDragStart,
    onDrop: onDrop,
    title: "Free input"
  }, /*#__PURE__*/React.createElement("div", {
    className: styles$3['type-free-input__container']
  }, /*#__PURE__*/React.createElement(FieldSet, {
    className: styles$3['type-free-input__content'],
    legend: "Define a title related to a assignment"
  }, /*#__PURE__*/React.createElement("div", {
    className: styles$3['type-free-input__inputs']
  }, /*#__PURE__*/React.createElement("div", {
    className: styles$3['type-free-input__question']
  }, /*#__PURE__*/React.createElement(Label, {
    htmlFor: freeInput.titleInputName
  }, "Question title"), /*#__PURE__*/React.createElement(FieldSetInput, {
    inputIdentifier: freeInput.titleInputName,
    name: freeInput.titleInputName,
    onChange: onFreeInputTitleChange,
    placeholder: "Write a question",
    state: typeof freeInput.fieldsState !== 'undefined' && freeInput.fieldsState.titleHasError ? {
      type: 'error'
    } : undefined,
    value: freeInput.title
  })), /*#__PURE__*/React.createElement("span", {
    className: classNames('text-regular-base-gray-700', styles$3['type-free-input__as'])
  }, "as"), /*#__PURE__*/React.createElement("div", {
    className: classNames('w-100', styles$3['type-free-input__assignment'])
  }, /*#__PURE__*/React.createElement(Label, {
    htmlFor: freeInput.assignmentInputName,
    screenReaderOnly: true
  }, "Question assignment"), /*#__PURE__*/React.createElement(FieldSetInput, {
    inputIdentifier: freeInput.assignmentInputName,
    name: freeInput.assignmentInputName,
    onChange: onFreeInputAssignmentChange,
    placeholder: "Value",
    state: typeof freeInput.fieldsState !== 'undefined' && freeInput.fieldsState.assignmentHasError ? {
      type: 'error'
    } : undefined,
    value: freeInput.assignment
  }))), /*#__PURE__*/React.createElement(ErrorMessage, {
    isHidden: typeof freeInput.fieldsState === 'undefined'
  }, freeInput.errorMessage)), /*#__PURE__*/React.createElement("div", {
    className: "d-flex"
  }, /*#__PURE__*/React.createElement("div", {
    className: styles$3['type-free-input__select-validation']
  }, /*#__PURE__*/React.createElement(Select, {
    label: "validation",
    onChange: onFreeInputSelectNameChange(freeInput.validationSelectName),
    value: freeInput.validation
  }, freeInputSelectOptions.map(option => {
    return /*#__PURE__*/React.createElement(Option, {
      key: genericUtils.generateRandomTagId(),
      value: option.value
    }, option.name);
  }))), freeInput.validation === 'custom' && /*#__PURE__*/React.createElement("div", {
    className: "w-100"
  }, /*#__PURE__*/React.createElement(Input, {
    label: "Regex",
    name: freeInput.regexInputName,
    onChange: onFreeInputRegexChange,
    placeholder: "Insert a custom regex",
    state: typeof freeInput.regexErrorMessage === 'undefined' ? undefined : {
      message: freeInput.regexErrorMessage,
      type: 'error'
    },
    value: freeInput.regex
  })))));
};

var styles$2 = {"type-go-to-skill__select":"index-module_type-go-to-skill__select__7wvCV","type-go-to-skill__content":"index-module_type-go-to-skill__content__Kzyai"};

const TypeGoToSkill = ({
  goToSkillDetails,
  goToSkills,
  onGotoSkillSelectNameChange,
  onDeleteButtonClick,
  onDragOver,
  onDragStart,
  onDrop
}) => {
  return /*#__PURE__*/React.createElement(DragAndDropListItem, {
    deleteButton: {
      name: goToSkillDetails.elementId,
      onDeleteButtonClick
    },
    onDragOver: onDragOver,
    onDragStart: onDragStart,
    onDrop: onDrop,
    title: "go to skill"
  }, /*#__PURE__*/React.createElement("div", {
    className: styles$2['type-go-to-skill__content']
  }, /*#__PURE__*/React.createElement("div", {
    className: styles$2['type-go-to-skill__select']
  }, /*#__PURE__*/React.createElement(Select, {
    defaultText: typeof goToSkillDetails.goToSkillId === 'undefined' ? 'Select a skill' : undefined,
    label: "Redirect to",
    onChange: onGotoSkillSelectNameChange(goToSkillDetails.nameSelectName, goToSkills),
    state: typeof goToSkillDetails.errorMessage === 'undefined' ? undefined : {
      message: goToSkillDetails.errorMessage,
      type: 'error'
    },
    value: goToSkillDetails.goToSkillId
  }, goToSkills.map(goToSkill => {
    return /*#__PURE__*/React.createElement(Option, {
      key: genericUtils.generateRandomTagId(),
      value: goToSkill.value
    }, goToSkill.name);
  })))));
};

var styles$1 = {"answer-type-text__container-input":"index-module_answer-type-text__container-input__mEQKS","answer-type-text__input":"index-module_answer-type-text__input__km1hb","answer-type-picture__error-message":"index-module_answer-type-picture__error-message__BLduA","answer-type-picture__error-message--visible":"index-module_answer-type-picture__error-message--visible__QGX5o"};

/* eslint-disable @typescript-eslint/no-unsafe-argument */

const TypePicture = ({
  picture,
  onPictureAnswerChange,
  onDeleteButtonClick,
  onDragOver,
  onDragStart,
  onDrop
}) => {
  return /*#__PURE__*/React.createElement(DragAndDropListItem, {
    deleteButton: {
      name: picture.elementId,
      onDeleteButtonClick
    },
    onDragOver: onDragOver,
    onDragStart: onDragStart,
    onDrop: onDrop,
    title: "picture"
  }, /*#__PURE__*/React.createElement("div", {
    className: styles$1['answer-type-picture__container-input']
  }, /*#__PURE__*/React.createElement(Label, {
    htmlFor: picture.elementId
  }, "DISPLAYED MEDIA (Max size 5Mo)"), /*#__PURE__*/React.createElement(Upload, {
    className: styles$1['answer-type-picture__input'],
    htmlFor: picture.elementId,
    name: picture.inputName,
    onChange: onPictureAnswerChange,
    sizeLimit: 5e6,
    url: picture.url,
    value: picture.name
  }, "Upload"), /*#__PURE__*/React.createElement("div", {
    className: classNames(styles$1['answer-type-picture__error-message'], {
      [styles$1['answer-type-picture__error-message--visible']]: typeof picture.errorMessage !== 'undefined'
    })
  }, /*#__PURE__*/React.createElement(ErrorMessage, null, picture.errorMessage))));
};

var styles = {"answer-type-text__container-input":"index-module_answer-type-text__container-input__ePjiF","answer-type-text__input":"index-module_answer-type-text__input__58Jv4"};

/* eslint-disable @typescript-eslint/no-unsafe-argument */

const TypeText = ({
  textDetails,
  onTextAssistantAnswerChange,
  onDeleteButtonClick,
  onDragOver,
  onDragStart,
  onDrop
}) => {
  return /*#__PURE__*/React.createElement(DragAndDropListItem, {
    deleteButton: {
      name: textDetails.elementId,
      onDeleteButtonClick
    },
    onDragOver: onDragOver,
    onDragStart: onDragStart,
    onDrop: onDrop,
    title: "text"
  }, /*#__PURE__*/React.createElement("div", {
    className: styles['answer-type-text__container-input']
  }, /*#__PURE__*/React.createElement(Input, {
    className: styles['answer-type-text__input'],
    label: "Assistant answer",
    name: textDetails.titleInputName,
    onChange: onTextAssistantAnswerChange,
    placeholder: "Write an answer",
    state: typeof textDetails.errorMessage === 'undefined' ? undefined : {
      message: textDetails.errorMessage,
      type: 'error'
    },
    value: textDetails.title
  })));
};

const component = (getOneSmartSkillsInfos, getOneSmartSkillFormDetails, createOneSmartSkill, updateOneSmartSkill, history) => ({
  botId
}) => {
  return /*#__PURE__*/React.createElement(SmartSkillsFormViewer, {
    botId: botId,
    createOneSmartSkill: createOneSmartSkill,
    getOneSmartSkillFormDetails: getOneSmartSkillFormDetails,
    getOneSmartSkillsInfos: getOneSmartSkillsInfos,
    history: history,
    updateOneSmartSkill: updateOneSmartSkill
  });
};

export { component };
